const movies = [
  {
    title: "Anand",
    year: "1971",
    genres: ["Drama"],
    ratings: [
      5, 6, 8, 1, 2, 5, 8, 2, 8, 6, 10, 6, 3, 7, 6, 4, 1, 10, 3, 6, 5, 3, 9, 8,
      7, 2, 4, 10, 5, 9,
    ],
    poster:
      "MV5BMjE0Mzk3OTk2NF5BMl5BanBnXkFtZTgwMTQ1NDk5NTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT122M",
    releaseDate: "1971-03-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A melodramatic tale of a man with a terminal disease. The story begins with Dr Bhaksar winning a literary prize for his book about a patient called Anand. The rest is flashback. Anand, the title character, is suffering from lymphosarcoma of the intestine. He, however appears to be cheerful on the outside and is determined to extract as much pleasure from his remaining lifespan as is possible. Dr. Bhaskar his physician tends to Anand in his last days. After Anand dies we can however still hear his voice which was recorded on a tape. Dr Bhakser writes a book on his patient and wins a literary prize for it                Written by\nAnonymous",
    actors: ["Rajesh Khanna", "Amitabh Bachchan", "Sumita Sanyal"],
    imdbRating: 8.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE0Mzk3OTk2NF5BMl5BanBnXkFtZTgwMTQ1NDk5NTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Dangal",
    year: "2016",
    genres: ["Action", "Biography", "Drama"],
    ratings: [
      5, 6, 3, 9, 6, 9, 7, 6, 4, 2, 7, 1, 10, 7, 7, 6, 2, 4, 2, 5, 7, 8, 6, 7,
      3, 3, 4, 6, 8, 1,
    ],
    poster:
      "MV5BMTQ4MzQzMzM2Nl5BMl5BanBnXkFtZTgwMTQ1NzU3MDI@._V1_SY500_CR0,0,356,500_AL_.jpg",
    contentRating: "",
    duration: "PT161M",
    releaseDate: "2016-12-23",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Biopic of Mahavir Singh Phogat, who taught wrestling to his daughters Babita Kumari and Geeta Phogat. Geeta Phogat was India's first female wrestler to win at the 2010 Commonwealth Games, where she won the gold medal (55 kg) while her sister Babita Kumari won the silver (52 kg).                Written by\nDibyayan_Chakravorty",
    actors: ["Aamir Khan", "Sakshi Tanwar", "Fatima Sana Shaikh"],
    imdbRating: 8.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ4MzQzMzM2Nl5BMl5BanBnXkFtZTgwMTQ1NzU3MDI@._V1_SY500_CR0,0,356,500_AL_.jpg",
  },
  {
    title: "Drishyam",
    year: "2013",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      4, 7, 4, 6, 1, 8, 6, 4, 4, 6, 4, 1, 5, 9, 4, 7, 5, 6, 5, 1, 8, 3, 9, 1, 7,
      4, 6, 10, 6, 6,
    ],
    poster:
      "MV5BYmY3MzYwMGUtOWMxYS00OGVhLWFjNmUtYzlkNGVmY2ZkMjA3XkEyXkFqcGdeQXVyMTExNDQ2MTI@._V1_SX330_CR0,0,330,432_AL_.jpg",
    contentRating: "",
    duration: "PT160M",
    releaseDate: "2013-12-19",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Georgekutty (Mohanlal) is a cable TV network owner in a remote and hilly village in Kerala. He lives a happy life with his wife and 2 girls. The first half revolves around the depiction of their happy family. Anju (Ansiba), Georgekutty's daughter goes to a school trip in between the proceedings. After a few days a guy who had been at the school trip with her meets Anju. He blackmails her with a video of her that he had captured during the school trip. In the course of events he is accidentally killed by Rani (Meena) and Anju. Georgekutty on returning home is appraised of the events and thus begins a cat and mouse game as the murdered person is the son of IG Geeta Prabhakar (Asha Sharath) and Prabhakar (Siddique). How the family weathers the storm that ensues during the murder investigation forms the rest of the story leading to a deeply satisfying and unexpected climax.                Written by\nAthul",
    actors: ["Mohanlal", "Meena", "Ansiba"],
    imdbRating: 8.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYmY3MzYwMGUtOWMxYS00OGVhLWFjNmUtYzlkNGVmY2ZkMjA3XkEyXkFqcGdeQXVyMTExNDQ2MTI@._V1_SX330_CR0,0,330,432_AL_.jpg",
  },
  {
    title: "Nayakan",
    year: "1987",
    genres: ["Crime", "Drama"],
    ratings: [
      6, 3, 2, 1, 8, 10, 5, 8, 1, 10, 6, 9, 6, 5, 1, 6, 9, 1, 1, 3, 3, 9, 4, 9,
      8, 1, 3, 8, 4, 10,
    ],
    poster:
      "MV5BNTI2Zjc5ODMtNGE0NC00YjU5LTk0NjktZjU4ZDRlZDFkZWU0XkEyXkFqcGdeQXVyNjc5Mjg4Nzc@._V1_SY480_SX320_AL_.jpg",
    contentRating: "",
    duration: "PT145M",
    releaseDate: "1987-07-31",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A small boy (Ratnavelu) from Tamilnadu sees his father, a labor leader, killed in cold blood by a policeman. He kills the policeman and runs away to the city of Bombay. From there, the story traces his ascent to become a mafia chief (Velu Naicker).                Written by\nSathyanarayanan Narayanaswamy <sathya@ntd.comsat.com>",
    actors: ["Kamal Haasan", "Saranya Ponvannan", "Delhi Ganesh"],
    imdbRating: 8.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTI2Zjc5ODMtNGE0NC00YjU5LTk0NjktZjU4ZDRlZDFkZWU0XkEyXkFqcGdeQXVyNjc5Mjg4Nzc@._V1_SY480_SX320_AL_.jpg",
  },
  {
    title: "Anbe Sivam",
    year: "2003",
    genres: ["Adventure", "Comedy", "Drama"],
    ratings: [
      9, 7, 1, 6, 10, 5, 9, 5, 3, 7, 2, 10, 2, 3, 1, 2, 3, 1, 3, 3, 8, 7, 9, 3,
      4, 9, 3, 1, 10, 1,
    ],
    poster:
      "MV5BNWQxY2MyNmUtOTkxZC00MmQ3LWFkMjMtNWU3YmFlZDM5YTBhXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SX352_CR0,0,352,499_AL_.jpg",
    contentRating: "",
    duration: "PT160M",
    releaseDate: "2003-01-14",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Nallasivam (Kamal Haasan) and Anbarasu (Madhavan) are drawn together by the strings of fate after they come into contact at the Bhuvaneshwar airport. Anbarasu is an advertisement director, while Nallasivam is a trade unionist. Fate entwines their travel plans, and they end up travelling to Chennai together. In the course of their journey, Anbarasu, born with a golden spoon, is touched by the realities of the sufferings of a normal human being when he witnesses the dead and the injured during a train accident, and he volunteers to donate his blood, which is of a very rare group, despite his fear of blood. The flashback of Nallasivam is recounted during one of their journeys. Nallasivam is a communist trade unionist, who fights for higher wages for his comrades. By chance, he falls in love with the daughter Bala (Kiran) of a rich industrialist, Bala's father, Padaiyacchi (Nasser). Due to the opposition, they plan to elope and get married, but unfortunately, Nallasivam meets with an ...                Written by\nNiranjan Venkatraman <v.niranjan@ieee.org>",
    actors: ["Kamal Haasan", "Madhavan", "Kiran Rathod"],
    imdbRating: 8.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNWQxY2MyNmUtOTkxZC00MmQ3LWFkMjMtNWU3YmFlZDM5YTBhXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SX352_CR0,0,352,499_AL_.jpg",
  },
  {
    title: "Gol Maal",
    year: "1979",
    genres: ["Comedy", "Romance"],
    ratings: [
      7, 9, 10, 8, 8, 9, 8, 9, 9, 2, 9, 4, 3, 9, 3, 3, 10, 8, 8, 10, 3, 10, 9,
      3, 3, 6, 2, 2, 6, 4,
    ],
    poster:
      "MV5BMjA4OTczODgxNF5BMl5BanBnXkFtZTgwMDAzMTU2NDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT144M",
    releaseDate: "1979-04-20",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Ramprasad is a recent college graduate who finds a job with a finicky man, Bhavani Shankar, who believes that a man without a mustache is a man without a character. Bhavani Shankar is also against any of his employees indulging in recreation of any kind. When Ramprasad is caught by his boss at a soccer match, he has to invent a twin brother, the clean-shaven Laxman Prasad, to save his job. When Bhavani's daughter falls in love with the clean-shaven Laxman Prasad, and insists on marrying him, and Bhavani insists she should marry Ramprasad, things take a whacky turn. A fake mother and a hilarious chase are other enjoyable features involved in this comedy.                Written by\nVijay",
    actors: ["Amol Palekar", "Bindiya Goswami", "Deven Verma"],
    imdbRating: 8.7,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA4OTczODgxNF5BMl5BanBnXkFtZTgwMDAzMTU2NDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Black Friday",
    year: "2004",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      8, 5, 10, 2, 4, 7, 4, 4, 10, 1, 7, 8, 9, 4, 5, 8, 10, 1, 8, 4, 2, 4, 3, 4,
      8, 6, 3, 2, 4, 1,
    ],
    poster:
      "MV5BMmU1NDhjYTQtYjQxYy00MjlmLWIxMjItMjllMmE2NDRlY2ZhXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_SX400_AL_.jpg",
    contentRating: "",
    duration: "PT143M",
    releaseDate: "2007-02-09",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A dramatic presentation of the bomb blasts that rocked Bombay on March 12, 1993, displays the police investigation, amidst allegations of human rights violations, led by DCP Rakesh Maria, in tracking down the suspects, especially Bashir Khan. Bashir managed to elude authorities by re-locating to Rajasthan, Uttar Pradesh, Delhi, and West Bengal, after finally being apprehended in Bombay. His confession and subsequent flashbacks showcases the apathy shown by authorities who refused to intervene during the destruction of the sacred Babri Masjid by Hindu Kar Sevaks, and the inability of the police to fulfill their mandate and protect the vulnerable, forcing many to flee to other locations. The subsequent aftermath that succeeded in irreversibly polarizing communities in Bombay; Pakistan's involvement in training and arms' supplies; the main alleged suspects, Dawood Ibrahim, and Mushtaq Memon, sought refuge in Dubai, United Arab Emirates, while Indian politicians made a cosmetic move to ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Kay Kay Menon", "Pavan Malhotra", "Aditya Srivastava"],
    imdbRating: 8.6,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMmU1NDhjYTQtYjQxYy00MjlmLWIxMjItMjllMmE2NDRlY2ZhXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_SX400_AL_.jpg",
  },
  {
    title: "Taare Zameen Par",
    year: "2007",
    genres: ["Drama", "Family", "Music"],
    ratings: [
      1, 9, 10, 4, 1, 6, 2, 9, 5, 10, 4, 5, 7, 6, 3, 8, 7, 4, 1, 2, 1, 5, 7, 10,
      3, 10, 8, 2, 4, 3,
    ],
    poster:
      "MV5BNTVmYTk2NjAtYzY3MS00YjFjLTlkYzktYzg3YzMyZDQyOWRiXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "PG",
    duration: "PT165M",
    releaseDate: "2008-12-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Ishaan Awasthi is an eight-year-old whose world is filled with wonders that no one else seems to appreciate; colours, fish, dogs and kites are just not important in the world of adults, who are much more interested in things like homework, marks and neatness. And Ishaan just cannot seem to get anything right in class. When he gets into far more trouble than his parents can handle, he is packed off to a boarding school to 'be disciplined'. Things are no different at his new school, and Ishaan has to contend with the added trauma of separation from his family. One day a new art teacher bursts onto the scene, Ram Shankar Nikumbh, who infects the students with joy and optimism. He breaks all the rules of 'how things are done' by asking them to think, dream and imagine, and all the children respond with enthusiasm, all except Ishaan. Nikumbh soon realizes that Ishaan is very unhappy, and he sets out to discover why. With time, patience and care, he ultimately helps Ishaan find himself.                Written by\nAnonymous",
    actors: ["Darsheel Safary", "Aamir Khan", "Tanay Chheda"],
    imdbRating: 8.5,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTVmYTk2NjAtYzY3MS00YjFjLTlkYzktYzg3YzMyZDQyOWRiXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Jaane Bhi Do Yaaro",
    year: "1983",
    genres: ["Comedy", "Drama"],
    ratings: [
      9, 10, 10, 7, 1, 2, 6, 7, 10, 10, 8, 2, 8, 3, 7, 3, 4, 8, 5, 2, 10, 9, 5,
      10, 10, 5, 7, 9, 10, 2,
    ],
    poster:
      "MV5BNzQ0MzA3NDY3Nl5BMl5BanBnXkFtZTcwOTAwMzIzMg@@._V1_SY235_CR0,0,177,235_AL_.jpg",
    contentRating: "",
    duration: "PT132M",
    releaseDate: "1983-08-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Vinod (Naseeruddin Shah) and Sudhir (Ravi Baswani) are two professional photographers trying to start a photo studio. The first real assignment that they get, from the activist magazine Khabardar (literally meaning beware), draws them into the shady world of Bombay real estate. They discover that one of the biggest builders in Bombay, Tarneja, is trying to bribe Municipal Commissioner D'Mello (Satish Shah) into giving him a bridge contract. Meanwhile D'Mello is negotiating with Tarneja's arch rival Ahuja (Om Puri). The contract is finally awarded to a third person. By chance Vinod and Sudhir find out that Tarneja has murdered D'Mello...                Written by\n<bagchi@jhu.edu>",
    actors: ["Naseeruddin Shah", "Ravi Baswani", "Bhakti Barve"],
    imdbRating: 8.6,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzQ0MzA3NDY3Nl5BMl5BanBnXkFtZTcwOTAwMzIzMg@@._V1_SY235_CR0,0,177,235_AL_.jpg",
  },
  {
    title: "3 Idiots",
    year: "2009",
    genres: ["Comedy", "Drama"],
    ratings: [
      5, 4, 8, 7, 2, 7, 1, 10, 1, 2, 3, 8, 4, 9, 4, 5, 5, 1, 3, 6, 6, 3, 8, 5,
      6, 8, 8, 1, 5, 7,
    ],
    poster:
      "MV5BZWRlNDdkNzItMzhlZC00YTdmLWIwNjktYjY5NjQ1ZmQ3N2FkXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SY500_CR0,0,373,500_AL_.jpg",
    contentRating: "11",
    duration: "PT170M",
    releaseDate: "2009-12-25",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Farhan Qureshi and Raju Rastogi want to re-unite with their fellow collegian, Rancho, after faking a stroke aboard an Air India plane, and excusing himself from his wife - trouser less - respectively. Enroute, they encounter another student, Chatur Ramalingam, now a successful businessman, who reminds them of a bet they had undertaken 10 years ago. The trio, while recollecting hilarious antics, including their run-ins with the Dean of Delhi's Imperial College of Engineering, Viru Sahastrabudhe, race to locate Rancho, at his last known address - little knowing the secret that was kept from them all this time.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Aamir Khan", "Madhavan", "Mona Singh"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZWRlNDdkNzItMzhlZC00YTdmLWIwNjktYjY5NjQ1ZmQ3N2FkXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SY500_CR0,0,373,500_AL_.jpg",
  },
  {
    title: "Chupke Chupke",
    year: "1975",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      1, 1, 3, 2, 2, 1, 1, 7, 1, 2, 6, 8, 7, 8, 10, 7, 3, 4, 1, 10, 4, 8, 10, 8,
      7, 8, 10, 7, 9, 10,
    ],
    poster:
      "MV5BMjAzMjMzMzU2N15BMl5BanBnXkFtZTgwMDkxOTE3NDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT127M",
    releaseDate: "1975-04-11",
    averageRating: 0,
    originalTitle: "",
    storyline:
      'Raghav brags that he can smell a rat or an impersonator automatically, and Dr. Parimal Tripathi decides to take him on - result: funny family slapstick comedy, with a dose of pure Hindi and Urdu thrown in, especially the dialogue delivery by Om Prakash, Dharmendra, and Amitabh Bachchan. Notable songs are :Sare ga ma, ma sa re ga ma...."; "Ab ke sajan sawan me, aag lagegi badan mein, ghata barshegi, magar tarsegi nazar, mil na sakenghe do mahn ek hi aagan mein..."; "Chupke chupke chal di purvaiya, basuri bajaike raas rachaye daiya re daiya, chupke...".                Written by\nrAjOo (gunwanti@hotmail.com)',
    actors: ["Dharmendra", "Sharmila Tagore", "Amitabh Bachchan"],
    imdbRating: 8.5,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjAzMjMzMzU2N15BMl5BanBnXkFtZTgwMDkxOTE3NDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Pather Panchali",
    year: "1955",
    genres: ["Drama"],
    ratings: [
      10, 2, 7, 10, 1, 9, 6, 8, 10, 5, 10, 5, 9, 7, 1, 7, 4, 8, 5, 2, 3, 6, 9,
      7, 3, 8, 6, 8, 10, 9,
    ],
    poster:
      "MV5BMjA0Njg1OTg0Nl5BMl5BanBnXkFtZTgwNzQ2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
    contentRating: "",
    duration: "PT125M",
    releaseDate: "1955-08-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The story of a young boy, Apu, and life in his small Indian village. His parents are quite poor - his father Harihar, a writer and poet, gave away the family's fruit orchard to settle his brother's debts. His sister Durga and an old aunt also still lives with them. His mother Sarbojaya bears the brunt of the family's situation. She scrapes by and sells her personal possessions to put food on the table and has to bear the taunts of her neighbors as Durga is always stealing fruit from their orchard. Things get worse when Harihar disappears for five months and Durga falls ill. Even after Harihar returns, the family is left with few alternatives.                Written by\ngarykmcd",
    actors: ["Kanu Bannerjee", "Karuna Bannerjee", "Subir Banerjee"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA0Njg1OTg0Nl5BMl5BanBnXkFtZTgwNzQ2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
  },
  {
    title: "A Wednesday",
    year: "2008",
    genres: ["Crime", "Drama", "Mystery"],
    ratings: [
      8, 5, 4, 3, 10, 10, 1, 1, 6, 2, 8, 1, 2, 2, 6, 2, 7, 1, 4, 8, 3, 1, 4, 9,
      2, 6, 6, 3, 9, 10,
    ],
    poster:
      "MV5BMTAzODEzMjE1MTJeQTJeQWpwZ15BbWU3MDE3NjQ5Mzk@._V1_SY492_SX324_AL_.jpg",
    contentRating: "",
    duration: "PT104M",
    releaseDate: "2008-09-05",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A man calls up the Mumbai police, and tells them he has placed five different bombs in the city -- all set to go off in some time. He wants four terrorists in exchange. Does he get them? Who is behind it all? What's his motive? Is there more than meets the eye?                Written by\nSaurabh Roy",
    actors: ["Anupam Kher", "Naseeruddin Shah", "Jimmy Shergill"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTAzODEzMjE1MTJeQTJeQWpwZ15BbWU3MDE3NjQ5Mzk@._V1_SY492_SX324_AL_.jpg",
  },
  {
    title: "Andaz Apna Apna",
    year: "1994",
    genres: ["Comedy", "Family", "Romance"],
    ratings: [
      2, 6, 5, 4, 1, 1, 4, 4, 5, 10, 8, 9, 9, 5, 5, 2, 9, 8, 7, 10, 3, 7, 9, 10,
      7, 7, 1, 6, 2, 10,
    ],
    poster:
      "MV5BNWE2MjhjMmMtNzQyMS00MmI0LTlkOTUtZDVlZjFlNmZkNDgyL2ltYWdlXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY462_CR0,0,331,462_AL_.jpg",
    contentRating: "",
    duration: "PT160M",
    releaseDate: "1994-11-04",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Amar and Prem are two rivals who belonging to middle-class families with no scope of future advancement. Both individually, without the knowledge of the other decide to take matters into their hands and find ways to get rich quickly. Chaos and acrimony result when both find each other at loggerheads when both arrive to win the hand of the daughter of multi-millionaire Ram Gopal Bajaj amidst considerable upheavals when Shyam, the twin brother of Ram, decides to do away with Ram and assume his identity and thus take over the estate of the Bajaj family.                Written by\nSonia",
    actors: ["Aamir Khan", "Salman Khan", "Raveena Tandon"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNWE2MjhjMmMtNzQyMS00MmI0LTlkOTUtZDVlZjFlNmZkNDgyL2ltYWdlXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY462_CR0,0,331,462_AL_.jpg",
  },
  {
    title: "Hera Pheri",
    year: "2000",
    genres: ["Comedy", "Crime", "Thriller"],
    ratings: [
      4, 7, 2, 5, 2, 10, 10, 7, 5, 8, 9, 3, 3, 6, 7, 8, 10, 4, 6, 4, 8, 6, 4, 8,
      7, 6, 2, 5, 5, 5,
    ],
    poster:
      "MV5BZTYwNDdmNmEtOGZhYS00MjRiLWIzOWUtNDQxNzg4ZTVjMGE1XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_SX350_AL_.jpg",
    contentRating: "",
    duration: "PT156M",
    releaseDate: "2000-03-31",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Baburao is a landlord in India, who is very near-sighted, and always in financial trouble. He has a tenant named Raja, who has not paid his rent for several months. He also has anther tenant named Shyam, who has come to the city to look for a job in his late father's place, but is unable to find employment. The three men quarrel amongst themselves frequently. Then one day, the three men get a phone call from a kidnapper named Kabira, and decide to make use of this phone call to overcome their financial problems - pretend to be the real kidnappers, increase the ransom amount, keep the incremental amount for themselves, and then give the original ransom demanded to Kabira. Will they get away with this idea?                Written by\nTanya",
    actors: ["Akshay Kumar", "Paresh Rawal", "Sunil Shetty"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZTYwNDdmNmEtOGZhYS00MjRiLWIzOWUtNDQxNzg4ZTVjMGE1XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_SX350_AL_.jpg",
  },
  {
    title: "Drishyam",
    year: "2015",
    genres: ["Crime", "Drama", "Mystery"],
    ratings: [
      2, 4, 3, 10, 10, 7, 3, 1, 7, 9, 1, 5, 8, 2, 2, 7, 7, 5, 2, 9, 9, 5, 3, 2,
      4, 2, 3, 1, 4, 1,
    ],
    poster:
      "MV5BMTYyMjgyNDY3N15BMl5BanBnXkFtZTgwOTMzNTE5NTE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT163M",
    releaseDate: "2015-07-31",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Vijay Salgaonkar runs a cable TV network in a remote and hilly village of Goa. He lives a happy life with his wife Nandini and two daughters. A 4th grade dropout & an orphan, Vijay has worked his way towards success with his sheer hard-work & street smartness in order to provide for his family who mean the world to him. A man of few means & needs; Vijay believes life is to be lived simplistically - his wife, while she loves him devoutly, wants Vijay's thrifty & miserly behavior to end and wants the world for her family. If there's one thing that Vijay cannot live without, it is his passion for watching films. Such is his 'filmy' obsession that he doesn't mind staying up all night at his office binging on TV movies! In a bizarre turn of events; a teenage boy goes missing; he is the son of a headstrong & no-nonsense cop; IG Meera Deshmukh and the Salgaonkar family is the prime suspect! Will a humble & middle class man, be able to protect his family from oppression of the powerful? How ...                Written by\nDhruvi Dokania",
    actors: ["Ajay Devgn", "Shriya Saran", "Tabu"],
    imdbRating: 8.5,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYyMjgyNDY3N15BMl5BanBnXkFtZTgwOTMzNTE5NTE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Sholay",
    year: "1975",
    genres: ["Action", "Adventure", "Comedy"],
    ratings: [
      2, 4, 1, 9, 5, 8, 5, 7, 8, 4, 9, 7, 4, 1, 3, 3, 5, 7, 7, 1, 10, 9, 4, 1,
      10, 3, 6, 7, 6, 6,
    ],
    poster:
      "MV5BOWQ0YTUzYzItYjI0MC00OTZmLWE1MWQtY2EzMzU2MTlmMmJjXkEyXkFqcGdeQXVyMDkwNTkwNg@@._V1_SY383_CR0,0,292,383_AL_.jpg",
    contentRating: "",
    duration: "PT198M",
    releaseDate: "1975-08-15",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Sholay means embers in Hindi. In this particular movie, a Police Officer, who's family was killed by a bandit named Gabbar Singh, decides to fight fire with fire and recruits two convicts, Jai and Veeru to capture Gabbar. He approaches them in jail, puts the proposal in front of them, and they agree to bring in Gabbar Singh alive - for a hefty price. After their discharge from jail, they travel by train to the village where the Police Officer lives - now with only his widowed daughter-in-law. The three band together to fight one of the most elusive and dreaded bandits of all time. Will the two ex-cons be able to bring Gabbar alive to the Police Officer?                Written by\nCalista",
    actors: ["Dharmendra", "Sanjeev Kumar", "Hema Malini"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOWQ0YTUzYzItYjI0MC00OTZmLWE1MWQtY2EzMzU2MTlmMmJjXkEyXkFqcGdeQXVyMDkwNTkwNg@@._V1_SY383_CR0,0,292,383_AL_.jpg",
  },
  {
    title: "Khosla Ka Ghosla!",
    year: "2006",
    genres: ["Comedy", "Crime", "Drama"],
    ratings: [
      10, 9, 5, 3, 4, 5, 4, 1, 4, 7, 8, 8, 10, 10, 5, 5, 5, 3, 5, 4, 8, 5, 8, 5,
      4, 4, 1, 1, 10, 10,
    ],
    poster:
      "MV5BZTg2YWFkOGMtYWExMy00YmFiLTk2YjctNTAzZDk5MjdhMzdlXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SX262_CR0,0,262,377_AL_.jpg",
    contentRating: "",
    duration: "PT135M",
    releaseDate: "2006-09-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "K.K. Khosla (Anupam Kher) is a middle class man living in New Delhi. He is a simple man with simple tastes. The plot starts with a scene where Khosla dreams about his death. The irony is that nobody cares about his death; instead his children & neighbours are more interested in their materialistic needs. One early morning in Delhi, Khosla wakes up and plans to go to the site where he has purchased a plot to build his house. He is accompanied by his wife, eldest son Bunty (Ranvir Shorey), second son Chironji Lal Khosla (Parvin Dabas), and his daughter. When they reach the spot they find that the site has been occupied by someone else and on further investigation find that it has been captured by a property usurping nexus headed by a man named Kishan Khurana (Boman Irani). Khurana demands Rs. 15 lakhs to vacate the plot, which Khosla refuses to give. Bunty gathers few local strongmen and forcefully destroys the walls and re-occupies the plot. But Khurana has the police on his side and ...                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Anupam Kher", "Boman Irani", "Parvin Dabas"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZTg2YWFkOGMtYWExMy00YmFiLTk2YjctNTAzZDk5MjdhMzdlXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SX262_CR0,0,262,377_AL_.jpg",
  },
  {
    title: "Rang De Basanti",
    year: "2006",
    genres: ["Comedy", "Drama", "History"],
    ratings: [
      9, 10, 7, 7, 1, 4, 9, 5, 1, 6, 3, 7, 4, 3, 9, 4, 2, 9, 6, 8, 6, 6, 6, 8,
      2, 8, 8, 4, 1, 2,
    ],
    poster:
      "MV5BMjEwNzA5MjAwN15BMl5BanBnXkFtZTcwMzY5MzIzMQ@@._V1_SY250_SX175_AL_.jpg",
    contentRating: "",
    duration: "PT157M",
    releaseDate: "2006-01-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A young idealistic English filmmaker, Sue, arrives in India to make a film on Indian revolutionaries Bhagat Singh, Chandrashekhar Azad and their contemporaries and their fight for freedom from the British Raj. Owing to a lack of funds, she recruits students from Delhi University to act in her docu-drama. She finds DJ, who graduated five years ago but still wants to be a part of the University because he doesn't think there's too much out there in the real world to look forward to. Karan, the son of Industrialist Rajnath Singhania, who shares an uncomfortable relationship with his father, but continues to live off him, albeit very grudgingly. Aslam, is a middle class Muslim boy, who lives in the by-lanes near Jama Masjid, poet, philosopher and guide to his friends. Sukhi, the group's baby, innocent, vulnerable and with a weakness for only one thing - girls. Laxman Pandey, the fundamentalist in the group, the only one who still believes that politics can make the world a better place ...                Written by\nfish_wow6",
    actors: ["Aamir Khan", "Soha Ali Khan", "Siddharth"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjEwNzA5MjAwN15BMl5BanBnXkFtZTcwMzY5MzIzMQ@@._V1_SY250_SX175_AL_.jpg",
  },
  {
    title: "Munna Bhai M.B.B.S.",
    year: "2003",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      2, 3, 6, 1, 7, 2, 1, 7, 4, 1, 7, 2, 7, 7, 1, 6, 8, 4, 6, 10, 10, 7, 6, 1,
      9, 6, 7, 3, 4, 9,
    ],
    poster:
      "MV5BY2JlMGI1YWQtYjBhMi00NTJiLTgxMzUtMGU4NThlZTAyYmMxXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "",
    duration: "PT156M",
    releaseDate: "2003-12-19",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "In India gangsters are called Bhai (brothers). One such Bhai is Munna, who is feared by everyone in Mumbai, a big city in India. He cons his village-based parents into believing that he is a doctor. He gets a shock when he finds out that they are coming to verify for themselves. So he transforms a rooming shanty house into a makeshift hospital, populated by patients, people he beats up. His parents arrive, are pleased, and happy that their son is well settled. They would like him to get married to a doctor's daughter. The marriage is arranged, but before the engagement, the bride's father finds out the truth about Munna, and cancels the marriage. Munna's humiliated parents see the truth for themselves, and hurt, they return home, leaving Munna with a strong desire to hurt the doctor - and force him to let his daughter get married to him - even if it means getting admitted in the medical college - with forged documents!!!                Written by\nSumitra (corrected by Carrie)",
    actors: ["Sunil Dutt", "Sanjay Dutt", "Arshad Warsi"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BY2JlMGI1YWQtYjBhMi00NTJiLTgxMzUtMGU4NThlZTAyYmMxXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Thani Oruvan",
    year: "2015",
    genres: ["Action", "Crime", "Thriller"],
    ratings: [
      4, 2, 6, 10, 10, 5, 1, 1, 8, 4, 8, 6, 9, 7, 2, 6, 2, 4, 8, 2, 1, 9, 1, 10,
      10, 3, 5, 10, 6, 2,
    ],
    poster:
      "MV5BNzgxMDc2Mjg3M15BMl5BanBnXkFtZTgwMzU4NTkxNzE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT160M",
    releaseDate: "2015-08-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Thoroughly frustrated with Industrialists and Politicians ruining the nation by denying the availability of cheap medicines, IPS officer Mithran is on a self-conceived quest to find the head of this medicine-mafia to channel all his anger towards him. But the ultimate villain, Siddharth Abhimanyu, who is also a decorated Scientist proves to be a ruthless and indomitable adversary.                Written by\nPipingHotViews",
    actors: ["Jeyam Ravi", "Arvind Swamy", "Nayanthara"],
    imdbRating: 8.6,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzgxMDc2Mjg3M15BMl5BanBnXkFtZTgwMzU4NTkxNzE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Talvar",
    year: "2015",
    genres: ["Biography", "Crime", "Drama"],
    ratings: [
      1, 10, 1, 3, 4, 1, 5, 8, 10, 6, 5, 2, 5, 10, 1, 8, 9, 8, 10, 9, 1, 7, 5,
      8, 9, 6, 6, 10, 4, 7,
    ],
    poster:
      "MV5BMTYzODg0Mjc4M15BMl5BanBnXkFtZTgwNzY4Mzc3NjE@._V1_SX369_CR0,0,369,499_AL_.jpg",
    contentRating: "",
    duration: "PT132M",
    releaseDate: "2015-10-02",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The story revolves around the mysterious murder cases of a 14-year girl, Shruti and the domestic help, Khempal who worked at her place. The film is based on the real life Noida Double Murder Case of 2008, where the parents were said to be the prime suspects of the murders. The film showcases three perspectives to the case which emerge as the investigation moves forward.",
    actors: ["Irrfan Khan", "Konkona Sen Sharma", "Neeraj Kabi"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYzODg0Mjc4M15BMl5BanBnXkFtZTgwNzY4Mzc3NjE@._V1_SX369_CR0,0,369,499_AL_.jpg",
  },
  {
    title: "Paan Singh Tomar",
    year: "2012",
    genres: ["Action", "Biography", "Crime"],
    ratings: [
      8, 1, 8, 9, 4, 7, 1, 10, 8, 2, 5, 1, 9, 7, 6, 8, 7, 3, 4, 3, 6, 7, 7, 4,
      5, 4, 8, 8, 2, 4,
    ],
    poster:
      "MV5BNTgwODM5OTMzN15BMl5BanBnXkFtZTcwMTA3NzI1Nw@@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT135M",
    releaseDate: "2012-03-02",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Paan Singh Tomar is a Hindi-language film, based on the true story of a runner employed by the Army and has won Gold medal at Indian National Games but forced to become notorious baaghi. It is directed by Tigmanshu Dhulia.                Written by\nAnonymous",
    actors: ["Irrfan Khan", "Ravi Bhushan Bhartiya", "Mahie Gill"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTgwODM5OTMzN15BMl5BanBnXkFtZTcwMTA3NzI1Nw@@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Queen",
    year: "2013",
    genres: ["Adventure", "Comedy", "Drama"],
    ratings: [
      6, 4, 4, 1, 5, 3, 3, 7, 1, 9, 8, 2, 8, 3, 8, 8, 1, 7, 3, 2, 1, 4, 1, 4,
      10, 10, 1, 3, 4, 6,
    ],
    poster:
      "MV5BMTQ1ODUxMzA1Nl5BMl5BanBnXkFtZTgwNDk0NjMyMTE@._V1_SX300_CR0,0,300,433_AL_.jpg",
    contentRating: "",
    duration: "PT146M",
    releaseDate: "2014-03-07",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Queen is a movie about growing up. Rani (Kangana Ranaut) is a Delhi girl from a conservative family who is ditched by her fiancé just before her wedding. Shocked by this, she decides to set out on the planned honeymoon alone. As she travels the world and meets new people, she gains new experiences and discovers her own identity.                Written by\nAm. P.",
    actors: ["Kangana Ranaut", "Rajkummar Rao", "Lisa Haydon"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ1ODUxMzA1Nl5BMl5BanBnXkFtZTgwNDk0NjMyMTE@._V1_SX300_CR0,0,300,433_AL_.jpg",
  },
  {
    title: "Pink",
    year: "2016",
    genres: ["Drama", "Thriller"],
    ratings: [
      2, 5, 5, 1, 3, 10, 4, 1, 5, 2, 3, 6, 1, 2, 3, 1, 2, 2, 9, 7, 5, 6, 5, 2,
      10, 1, 7, 10, 2, 9,
    ],
    poster:
      "MV5BNGI1MTI1YTQtY2QwYi00YzUzLTg3NWYtNzExZDlhOTZmZWU0XkEyXkFqcGdeQXVyMDkwNTkwNg@@._V1_SY480_SX360_AL_.jpg",
    contentRating: "",
    duration: "PT136M",
    releaseDate: "2016-09-16",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Deepak is a lawyer suffering from bipolar disorder who experiences frequent mood swings. One night, Rajveer and his friends get drunk and try to molest Miss Arora and her two roommates leading to an accident. The film revolves around how Deepak fights the girls' case against these influential boys.                Written by\nVarunish Garg",
    actors: ["Tapsee Pannu", "Kirti Kulhari", "Andrea Tariang"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNGI1MTI1YTQtY2QwYi00YzUzLTg3NWYtNzExZDlhOTZmZWU0XkEyXkFqcGdeQXVyMDkwNTkwNg@@._V1_SY480_SX360_AL_.jpg",
  },
  {
    title: "Black",
    year: "2005",
    genres: ["Drama"],
    ratings: [
      7, 2, 9, 4, 4, 2, 2, 6, 7, 6, 10, 1, 1, 9, 4, 5, 8, 10, 5, 5, 9, 4, 4, 9,
      4, 3, 4, 10, 6, 8,
    ],
    poster:
      "MV5BNTI5MmE5M2UtZjIzYS00M2JjLWIwNDItYTY2ZWNiODBmYTBiXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY325_CR0,0,224,325_AL_.jpg",
    contentRating: "",
    duration: "PT122M",
    releaseDate: "2005-02-04",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Based in Simla, the McNallys are an Anglo-Indian family consisting of Paul and his wife, Catherine. Both are full of joy when Catherine gives birth to a baby girl, Michelle, but their joy is short-lived when they are told that Michellle cannot see nor hear. Both attempt to bring up Michelle in their own protective way, as a result Michelle is not exposed to the real world, and becomes increasingly violent and volatile. Things only get worse when Catherine gives birth to Sara, and Paul considers admitting Michelle in an asylum. It is here that Debraj Sahai enters their lives. Through his eager involvement, Michelle blossoms, grows, gives up her violence, even gets admitted in school with normal children. The years pass by, Michelle does not succeed in getting her graduation, and it is time for Debraj to bid adieu as he is having his own health problems. 12 years later, at the age of 40, Michelle does succeed in graduating in Arts, and it is shortly thereafter she will be re-united with...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Amitabh Bachchan", "Rani Mukerji", "Shernaz Patel"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTI5MmE5M2UtZjIzYS00M2JjLWIwNDItYTY2ZWNiODBmYTBiXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY325_CR0,0,224,325_AL_.jpg",
  },
  {
    title: "Udaan",
    year: "2010",
    genres: ["Drama"],
    ratings: [
      3, 7, 1, 8, 1, 5, 5, 7, 6, 7, 10, 4, 5, 7, 7, 4, 5, 4, 3, 10, 2, 7, 3, 8,
      7, 9, 4, 2, 6, 1,
    ],
    poster:
      "MV5BNzgxMzExMzUwNV5BMl5BanBnXkFtZTcwMDc2MjUwNA@@._V1_SX300_CR0,0,300,433_AL_.jpg",
    contentRating: "",
    duration: "PT134M",
    releaseDate: "2010-07-16",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "After being abandoned for eight straight years in boarding school, Rohan returns to the small industrial town of Jamshedpur and finds himself closeted with an authoritarian father and a younger half brother who he didn't even know existed. Forced to work in his father's steel factory and study engineering against his wishes, he strives to forge his own life out of his given circumstances and pursue his dream of being a writer.                Written by\nAnonymous",
    actors: ["Rajat Barmecha", "Sanjay Gandhi", "Ronit Roy"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzgxMzExMzUwNV5BMl5BanBnXkFtZTcwMDc2MjUwNA@@._V1_SX300_CR0,0,300,433_AL_.jpg",
  },
  {
    title: "Jo Jeeta Wohi Sikandar",
    year: "1992",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      5, 7, 4, 4, 1, 5, 6, 1, 1, 4, 4, 5, 5, 4, 6, 7, 4, 4, 2, 7, 9, 5, 7, 8, 2,
      4, 6, 6, 9, 4,
    ],
    poster:
      "MV5BNTU1ZjQwNDAtZDAwMC00OTcyLTg4MDUtOTUwYTU4N2M4YTgxXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,366,500_AL_.jpg",
    contentRating: "",
    duration: "PT174M",
    releaseDate: "1992-05-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The biggest sporting event for the school town of Nainital is the annual cycling race. Schools and colleges here range from those like Rajput and Xavier's for the spoilt rich kids to local ones like Model for the poorer kids. For the past two years the cycling race has been won by the arrogant Shekhar Malhotra (Deepak Tijori) of Rajput College. Sanju (Aamir Khan) and Ratan (Mamik) are bothers who attend Model and run a small local cafe. Their father (Kulbhushan Kharbanda) is obsessed by the desire to see Ratan become the cycling champion. Ratan on his part is the ideal son and elder brother to Sanju, good in everything he does and has been the runner-up to Shekhar in the cycling race. Sunju on the other hand is a prankster, not taking life seriously at all enjoying life with his friends among whom is Anjali (Ayesha Jhulka) who loves him silently. Sanju however turns his attention on the new girl on the block, Devika (Pooja Bedi) and convinces her he is rich. He uses the money his ...                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Aamir Khan", "Ayesha Jhulka", "Deepak Tijori"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTU1ZjQwNDAtZDAwMC00OTcyLTg4MDUtOTUwYTU4N2M4YTgxXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,366,500_AL_.jpg",
  },
  {
    title: "Gangs of Wasseypur",
    year: "2012",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      6, 10, 4, 2, 4, 1, 2, 8, 5, 7, 5, 6, 3, 9, 9, 6, 1, 5, 7, 1, 9, 9, 10, 4,
      3, 7, 7, 8, 7, 4,
    ],
    poster:
      "MV5BMTc5NjY4MjUwNF5BMl5BanBnXkFtZTgwODM3NzM5MzE@._V1_SY500_CR0,0,337,500_AL_.jpg",
    contentRating: "",
    duration: "PT320M",
    releaseDate: "2012-08-02",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Shahid Khan is exiled after impersonating the legendary Sultana Daku in order to rob British trains. Now outcast, Shahid becomes a worker at Ramadhir Singh's colliery, only to spur a revenge battle that passes on to generations. At the turn of the decade, Shahid's son, the philandering Sardar Khan vows to get his father's honor back, becoming the most feared man of Wasseypur.                Written by\nanonymous",
    actors: ["Manoj Bajpayee", "Richa Chadha", "Nawazuddin Siddiqui"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc5NjY4MjUwNF5BMl5BanBnXkFtZTgwODM3NzM5MzE@._V1_SY500_CR0,0,337,500_AL_.jpg",
  },
  {
    title: "Chak De! India",
    year: "2007",
    genres: ["Drama", "Family", "Sport"],
    ratings: [
      2, 9, 5, 5, 2, 10, 10, 3, 4, 5, 1, 6, 9, 1, 5, 1, 2, 4, 3, 5, 4, 8, 5, 9,
      8, 3, 3, 5, 8, 5,
    ],
    poster:
      "MV5BMTM2MjgyNDE5Nl5BMl5BanBnXkFtZTcwMzM1MDc4MQ@@._V1_SY250_CR0,0,166,250_AL_.jpg",
    contentRating: "",
    duration: "PT153M",
    releaseDate: "2007-08-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Kabir Khan lives a middle-class lifestyle along with his widowed mom in Delhi, India, and is the Captain of the Indian men's hockey team. He fails to score at the last tournament resulting in Pakistan winning the World Cup amidst allegations that he was more inclined toward his opponents due to his religion. Kabir and his mom move away and virtually disappear for seven years. Thereafter Kabir surfaces to be a Coach for the women's hockey team, consisting of 16 players from all over India, some of who do not communicate well. Kabir's disciplinarian style ends up offending the players, lead by the militant Bindia Naik, who decide not to participate unless he resigns amidst allegations that he is having an affair with soon to-be married Vidya Sharma, who he appoints as the new Captain. Things change after a brawl with eve-teasers at the local McDonald's, the girls accept Kabir, however, the Chair of the Indian Women Hockey Association, Tripathi, decides to pull out of the World Cup but ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Shah Rukh Khan", "Vidya Malvade", "Sagarika Ghatge"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM2MjgyNDE5Nl5BMl5BanBnXkFtZTcwMzM1MDc4MQ@@._V1_SY250_CR0,0,166,250_AL_.jpg",
  },
  {
    title: "Swades: We, the People",
    year: "2004",
    genres: ["Drama"],
    ratings: [
      5, 1, 2, 8, 3, 6, 5, 10, 1, 10, 8, 4, 3, 4, 1, 5, 1, 9, 9, 6, 4, 1, 5, 5,
      10, 4, 1, 1, 7, 7,
    ],
    poster:
      "MV5BYzExOTcwNjYtZTljMC00YTQ2LWI2YjYtNWFlYzQ0YTJhNzJmXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY377_CR0,0,261,377_AL_.jpg",
    contentRating: "",
    duration: "PT210M",
    releaseDate: "2004-12-17",
    averageRating: 0,
    originalTitle: "",
    storyline:
      'Set in modern day India, Swades is a film that tackles the issues that development throws up on a grass root level. It is to this India, which is colorful, heterogeneous and complex that Mohan Bhargava (Shah Rukh Khan), a bright young scientist working as a project manager in NASA, returns to on a quest to find his childhood nanny. The film uses the contrast between the highly developed world of NASA, which has been at the forefront of advances in space research, and this world back home in India, which is at the crossroads of development. Mohan\'s simple quest becomes the journey that every one of us goes through in search of that metaphysical and elusive place called "home".                Written by\nAnonymous',
    actors: ["Shah Rukh Khan", "Gayatri Joshi", "Kishori Balal"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYzExOTcwNjYtZTljMC00YTQ2LWI2YjYtNWFlYzQ0YTJhNzJmXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY377_CR0,0,261,377_AL_.jpg",
  },
  {
    title: "OMG: Oh My God!",
    year: "2012",
    genres: ["Comedy", "Drama", "Family"],
    ratings: [
      8, 6, 6, 6, 1, 5, 5, 3, 7, 2, 1, 2, 7, 6, 6, 5, 8, 7, 4, 7, 1, 9, 2, 8, 6,
      9, 6, 2, 3, 3,
    ],
    poster:
      "MV5BNDk0NDU1NzEwN15BMl5BanBnXkFtZTgwMTgyNTA2NjE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT125M",
    releaseDate: "2012-09-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Kanji Lalji Mehta, though an atheist, owns a small shop selling religious goods, concocting cock-and-bull stories to extract higher fees from his customers for his wares. When, in openly defying God, an earthquake destroys his (and only his) only source of income, with the insurance company refusing to pay up on the basis of it being an 'act of God', Kanjibhai takes God to the court. With many similarly unfortunate people pinning their hopes to him, Kanji's lack of courtroom experience may leave him unable to prove his point - that is, until approached by a man introducing himself as Krishna Vasudeva Yadav. Krishna helps Kanji win his case, his family and helps him find his faith in God, along the way showing how priests can turn religion into a business and that God can be found everywhere, particularly in a house of worship.                Written by\nsrijanarora-152-448595 / revised by statmanjeff",
    actors: ["Paresh Rawal", "Mithun Chakraborty", "Akshay Kumar"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDk0NDU1NzEwN15BMl5BanBnXkFtZTgwMTgyNTA2NjE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Bhaag Milkha Bhaag",
    year: "2013",
    genres: ["Action", "Biography", "Drama"],
    ratings: [
      9, 1, 9, 3, 10, 2, 5, 5, 1, 10, 7, 7, 3, 3, 2, 5, 2, 6, 8, 8, 7, 2, 2, 1,
      6, 8, 8, 1, 9, 8,
    ],
    poster:
      "MV5BMTY1Nzg4MjcwN15BMl5BanBnXkFtZTcwOTc1NTk1OQ@@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT186M",
    releaseDate: "2013-07-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      'The true story of the "Flying Sikh" - world champion runner and Olympian Milkha Singh -- who overcame the massacre of his family, civil war during the India-Pakistan partition, and homelessness to become one of India\'s most iconic athletes.                Written by\nReliance Big Pictures',
    actors: ["Farhan Akhtar", "Sonam Kapoor", "Pavan Malhotra"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTY1Nzg4MjcwN15BMl5BanBnXkFtZTcwOTc1NTk1OQ@@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Kahaani",
    year: "2012",
    genres: ["Drama", "Mystery", "Thriller"],
    ratings: [
      9, 10, 8, 1, 1, 1, 9, 9, 4, 10, 4, 8, 4, 5, 5, 9, 4, 7, 4, 4, 1, 9, 4, 5,
      1, 3, 1, 6, 9, 9,
    ],
    poster:
      "MV5BMTQ1NDI0NzkyOF5BMl5BanBnXkFtZTcwNzAyNzE2Nw@@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT122M",
    releaseDate: "2012-03-09",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Kolkata is abuzz with the preparations for the annual Durga Puja festival, as seven months pregnant Vidya Bagchi steps off the airplane from London. Her first stop is the local police station to file a missing person report. Weeks ago, her husband Arnab arrived in India for a job assignment. The first two weeks, they talked daily on the phone, and then without explanation, his calls stopped. Everywhere Vidya turns, no one can remember Arnab. There is no trace of him at the guest house or his workplace. But Vidya will not give up her search. Somewhere in Kolkata she will discover the dangerous truth.                Written by\nL. Hamre",
    actors: ["Vidya Balan", "Parambrata Chatterjee", "Dhritiman Chatterjee"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ1NDI0NzkyOF5BMl5BanBnXkFtZTcwNzAyNzE2Nw@@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Shahid",
    year: "2012",
    genres: ["Biography", "Crime", "Drama"],
    ratings: [
      1, 1, 6, 3, 5, 6, 3, 9, 5, 10, 6, 1, 6, 4, 5, 5, 3, 6, 10, 7, 10, 7, 3, 9,
      8, 9, 1, 4, 9, 5,
    ],
    poster:
      "MV5BMTYyMDE1NjQ1Nl5BMl5BanBnXkFtZTgwMDAyMTUzMDE@._V1_SY500_CR0,0,374,500_AL_.jpg",
    contentRating: "",
    duration: "PT129M",
    releaseDate: "2013-10-18",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Shahid traces the true story of slain human rights activist and lawyer Shahid Azmi. From attempting to become a terrorist to being wrongly imprisoned under a draconian anti-terrorism law to becoming a criminal lawyer Shahid traces the inspiring personal journey of a boy who became an unlikely messiah for human rights while following the rise of communal violence in India. This story of an impoverished Muslim struggling to come to terms with injustice, inequality and rising above his circumstances is an inspiring testament to the human spirit.                Written by\nAnonymous",
    actors: ["Rajkummar Rao", "Prabhleen Sandhu", "Mohammed Zeeshan Ayyub"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYyMDE1NjQ1Nl5BMl5BanBnXkFtZTgwMDAyMTUzMDE@._V1_SY500_CR0,0,374,500_AL_.jpg",
  },
  {
    title: "Dil Chahta Hai",
    year: "2001",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      5, 9, 1, 8, 9, 2, 9, 5, 5, 10, 5, 2, 10, 4, 1, 10, 3, 9, 7, 5, 6, 6, 7, 5,
      3, 10, 9, 5, 8, 1,
    ],
    poster:
      "MV5BOTIyODkwNzY2NF5BMl5BanBnXkFtZTgwMzE5NDUzNTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT183M",
    releaseDate: "2001-07-24",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Three young men Akash, Sameer, and Siddharth are close friends, but their tastes and characters are completely incompatible. So when Siddharth falls in love with a much older woman, Tara, a woman who has been unsuccessful in keeping her marriage intact as well as alcohol-dependent, widens the rift between the trio, forcing them to part company. Years later, the trio will be re-united, they will be much mature and understanding, but will they still accept Siddharth love for Tara, especially when they themselves have fallen in love with women around their respective ages?                Written by\nSonia",
    actors: ["Aamir Khan", "Saif Ali Khan", "Akshaye Khanna"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOTIyODkwNzY2NF5BMl5BanBnXkFtZTgwMzE5NDUzNTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Jigarthanda",
    year: "2014",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      6, 10, 10, 2, 1, 3, 8, 1, 10, 1, 3, 7, 10, 6, 2, 2, 3, 2, 4, 5, 10, 10,
      10, 3, 6, 9, 3, 1, 8, 9,
    ],
    poster:
      "MV5BODExZjUzMDktNWEwNy00MzRkLWI2ZTctZTNmZTViNDhkMmU2XkEyXkFqcGdeQXVyMjkxNzQ1NDI@._V1_SY266_SX195_AL_.jpg",
    contentRating: "",
    duration: "PT171M",
    releaseDate: "2014-08-01",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "When Karthik is given a task by his producer to come up with a gripping gangster flick infested with heavy dosage of violence, he focuses on Sethu, a ruthless gangster surrounded by quirky yet scary henchmen. Karthik discreetly tries his best to find out about Sethu to develop a film script, but fails miserably in all his attempts. However when he finally gets the chance to gain an insight into Sethu's life, disaster strikes as he gets caught in the mêlée following the discovery of a mole within Sethu's gang.                Written by\nPipingHotViews",
    actors: ["Siddharth", "Bobby Simha", "Lakshmi Menon"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BODExZjUzMDktNWEwNy00MzRkLWI2ZTctZTNmZTViNDhkMmU2XkEyXkFqcGdeQXVyMjkxNzQ1NDI@._V1_SY266_SX195_AL_.jpg",
  },
  {
    title: "Satya",
    year: "1998",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      9, 5, 5, 7, 10, 7, 1, 6, 2, 1, 2, 9, 9, 9, 3, 9, 3, 1, 8, 5, 5, 2, 10, 10,
      1, 7, 9, 10, 7, 9,
    ],
    poster:
      "MV5BMTMwMjk3MzA2OF5BMl5BanBnXkFtZTcwNjU2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
    contentRating: "",
    duration: "PT170M",
    releaseDate: "1998-07-03",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A young man named Satya (J.D Chakravarthy) comes to Mumbai from South India in search of a job. Jailed for something he did not do, the once-honest young man meets an underworld boss, Bhiku Mhatre (Manoj Bajpai) in jail and joins his gang. He lives in a poor neighborhood, where he meets, Vidya (Urmila Matondkar), who lives next door. She is not aware of his underworld connections. Satya slowly rises up the ranks of his gang, and becomes the most influential person. Satya is torn between his girlfriend and his gangster life.                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["J.D. Chakravarthi", "Urmila Matondkar", "Paresh Rawal"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTMwMjk3MzA2OF5BMl5BanBnXkFtZTcwNjU2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
  },
  {
    title: "Apur Sansar",
    year: "1959",
    genres: ["Drama"],
    ratings: [
      9, 2, 6, 8, 8, 7, 3, 1, 4, 5, 2, 2, 4, 10, 10, 10, 10, 2, 10, 5, 5, 2, 10,
      3, 6, 8, 9, 10, 2, 1,
    ],
    poster:
      "MV5BMTYxMjUzMDA2M15BMl5BanBnXkFtZTgwOTM2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
    contentRating: "",
    duration: "PT105M",
    releaseDate: "1959-05-01",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Apu is a jobless former student dreaming vaguely of a future as a writer. An old college friend talks him into a visit up-country to a village wedding. This changes his life, for when the bridegroom turns out to be mad, Apu's friend asks him to become the husband. After initial revulsion at the idea, Apu agrees. Apu takes his exquisite bride, Aparna, back to Calcutta. But Aparna dies while giving birth, Apu leaves Calcutta, crazy with grief, and his son Kajal is left abandoned with his wife's parents. Only after a long period of total indifference to worldly responsibilities, does Apu become capable of returning to the world.                Written by\nL.H. Wong <as9401k56@ntuvax.ntu.ac.sg>",
    actors: ["Soumitra Chatterjee", "Sharmila Tagore", "Alok Chakravarty"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYxMjUzMDA2M15BMl5BanBnXkFtZTgwOTM2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
  },
  {
    title: "PK",
    year: "2014",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      3, 2, 6, 2, 7, 5, 4, 1, 8, 9, 3, 3, 9, 10, 3, 10, 5, 7, 10, 5, 3, 3, 5, 7,
      1, 5, 8, 6, 5, 5,
    ],
    poster:
      "MV5BMTYzOTE2NjkxN15BMl5BanBnXkFtZTgwMDgzMTg0MzE@._V1_SY500_CR0,0,344,500_AL_.jpg",
    contentRating: "",
    duration: "PT153M",
    releaseDate: "2014-12-19",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "P. K. is a comedy of ideas about a stranger in the city, who asks questions that no one has asked before. They are innocent, child-like questions, but they bring about catastrophic answers. People who are set in their ways for generations, are forced to reappraise their world when they see it from PK's innocent eyes. In the process PK makes loyal friends and powerful foes. Mends broken lives and angers the establishment. P. K.'s childlike curiosity transforms into a spiritual odyssey for him and millions of others. The film is an ambitious and uniquely original exploration of complex philosophies. It is also a simple and humane tale of love, laughter and letting-go. Finally, it is a moving saga about a friendship between strangers from worlds apart.                Written by\nAbhijat Joshi",
    actors: ["Aamir Khan", "Anushka Sharma", "Sanjay Dutt"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYzOTE2NjkxN15BMl5BanBnXkFtZTgwMDgzMTg0MzE@._V1_SY500_CR0,0,344,500_AL_.jpg",
  },
  {
    title: "Lagaan",
    year: "2001",
    genres: ["Adventure", "Drama", "Musical"],
    ratings: [
      8, 8, 8, 7, 6, 7, 8, 3, 1, 6, 5, 3, 7, 5, 1, 6, 6, 4, 2, 10, 8, 4, 2, 2,
      6, 1, 7, 9, 5, 6,
    ],
    poster:
      "MV5BNDYxNWUzZmYtOGQxMC00MTdkLTkxOTctYzkyOGIwNWQxZjhmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "7",
    duration: "PT224M",
    releaseDate: "2002-08-30",
    averageRating: 0,
    originalTitle: "Lagaan: Once Upon a Time in India",
    storyline:
      "This is the story about the resilience shown by the Indians when they were under the British Rule. They are already taxed to the bone by the British and their cronies, but when Jack Russell announces that he will double the Lagaan (tax) from all villagers, they decide to oppose it. Leading the villagers is a handsome young man named Bhuvan, who challenges them to a game of cricket, a game that is to be played by veteran British cricket players, versus villagers, including Bhuvan himself, who have never played this game before, and do not even know a bat from a piece of wood. As the challenge is accepted, the interest grows and attracts Indians from all over the region, as well as the British from all over the country - as everyone gathers to see the 'fair play' that the British will display against their counter-parts, who are aided by none other than the sister, Elizabeth, of Captain Rusell.                Written by\nSumitra (corrected by Sonia)",
    actors: ["Aamir Khan", "Gracy Singh", "Rachel Shelley"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDYxNWUzZmYtOGQxMC00MTdkLTkxOTctYzkyOGIwNWQxZjhmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Aparajito",
    year: "1956",
    genres: ["Drama"],
    ratings: [
      10, 9, 8, 3, 4, 5, 1, 8, 10, 6, 4, 6, 10, 6, 2, 1, 1, 8, 3, 10, 9, 8, 7,
      3, 2, 4, 8, 1, 2, 5,
    ],
    poster:
      "MV5BMjI1NjI2OTM4N15BMl5BanBnXkFtZTgwMzQ2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
    contentRating: "",
    duration: "PT110M",
    releaseDate: "1956-10-11",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "After living awhile in Benares, 10 year old Apu and his mother move in with her uncle in a small Bengali village. Apu enters a local school, where he does well. By the time he graduates, he has a scholarship to study at a college in Calcutta. So off he goes. His mother is torn by his leaving, and by his growing independence. She loves her son very much and wants him to succeed, but she does not want to be left alone.                Written by\nJohn Oswalt <jao@jao.com>",
    actors: ["Smaran Ghosal", "Kamala Adhikari", "Lalchand Banerjee"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjI1NjI2OTM4N15BMl5BanBnXkFtZTgwMzQ2MzkwNzE@._V1_SY250_CR0,0,178,250_AL_.jpg",
  },
  {
    title: "Sarfarosh",
    year: "1999",
    genres: ["Action", "Adventure", "Drama"],
    ratings: [
      9, 3, 9, 4, 5, 10, 1, 3, 6, 2, 2, 5, 10, 8, 2, 1, 3, 2, 1, 4, 10, 1, 3, 9,
      9, 5, 2, 2, 6, 3,
    ],
    poster:
      "MV5BMTgyMDczOTE2M15BMl5BanBnXkFtZTcwMDY2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
    contentRating: "",
    duration: "PT174M",
    releaseDate: "1999-04-30",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Ajay Rathod is a no-nonsense police officer from Mumbai Crime Branch. Long time ago his elder brother was killed by terrorists which caused him to quit his medical studies and join Indian Police Service. He is a great admirer of Pakistan-based ghazal singer Gulfam Hassan. During one of Hassan's concerts, they meet for the first time and become great friends. Meanwhile, Ajay's investigation into the Pakistan-supported cross-border terrorism takes him to Rajasthan and reveals an unsettling truth about someone close to his heart.                Written by\nSoumitra",
    actors: ["Naseeruddin Shah", "Aamir Khan", "Sonali Bendre"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgyMDczOTE2M15BMl5BanBnXkFtZTcwMDY2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
  },
  {
    title: "Iqbal",
    year: "2005",
    genres: ["Drama"],
    ratings: [
      8, 5, 10, 2, 7, 8, 2, 3, 5, 3, 7, 2, 4, 2, 9, 4, 6, 6, 6, 10, 6, 10, 4, 4,
      1, 3, 9, 2, 7, 4,
    ],
    poster:
      "MV5BNDA5NDAzNTAyM15BMl5BanBnXkFtZTgwMzE1MDA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT132M",
    releaseDate: "2005-08-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "India - a Nation obsessed with cricket - and it is not very often one comes across anyone who loathes cricket as much as farmer Anwar Khan, who feels that it is a waste of time watching some grown men playing, not only getting paid, but costing the nation millions of lost work hours. His family, especially his wife, Saida, does not quite agree with him. As a matter of fact, she broke water when watching a cricket match with a TV set perched on a branch of a tree with almost the entire village in attendance. This is how Iqbal was born, followed by the birth of his sister, Khadija. Iqbal, though deaf and dumb, shared his mother's and sister's passion for cricket, he would tend to the buffaloes, who though all female, had been named after male cricketers, including Kapil Dev. While tending to them, he would stop and watch youngsters being trained by the renowned Guruji. When Guruji finds out about Iqbal's interest in the game, he recruits him, but lets him go when a dispute flares up ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Naseeruddin Shah", "Girish Karnad", "Shreyas Talpade"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDA5NDAzNTAyM15BMl5BanBnXkFtZTgwMzE1MDA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Roja",
    year: "1992",
    genres: ["Drama", "Romance", "Thriller"],
    ratings: [
      4, 9, 6, 8, 5, 3, 3, 3, 5, 2, 2, 9, 10, 3, 1, 1, 7, 3, 1, 3, 3, 7, 1, 6,
      2, 9, 8, 3, 8, 3,
    ],
    poster:
      "MV5BNzA2Yjg0ZmQtZWZmOC00YWZmLWIzNTktZDgyMjhjNjUyNzQ5XkEyXkFqcGdeQXVyMjAzMjcxNTE@._V1_SY500_CR0,0,347,500_AL_.jpg",
    contentRating: "",
    duration: "PT137M",
    releaseDate: "2003-01-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Roja, a young woman born and brought up in Southern India, prays that the handsome young man coming to see her sister will be her future brother-in-law, only to have the tables turned on her when he openly choses her over her sister (as her sister loves another). So Roja marries Rishi and they leave the village to settle in the city, where both fall in love. Rishi, who works for the Indian Government, is instructed to go to the troubled state of Kashmir on a classified mission. Roja also goes along. Then her innocent world is shattered when Rishi is abducted and held for ransom by a group of jihadist militants who want an independent Kashmir and the release of a terrorist held by the Indian military forces. Will the passionate appeal of this young woman move cold and ruthless military and politician's hearts and minds? Two of the songs are worth remembering after watching the Hindi-dubbed version of the movie: \"Dil hai chhotasa, chhotisi aasha, masti bhare man ki bholisi aasha, chand ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Arvind Swamy", "Madhoo", "Pankaj Kapur"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzA2Yjg0ZmQtZWZmOC00YWZmLWIzNTktZDgyMjhjNjUyNzQ5XkEyXkFqcGdeQXVyMjAzMjcxNTE@._V1_SY500_CR0,0,347,500_AL_.jpg",
  },
  {
    title: "Maqbool",
    year: "2003",
    genres: ["Crime", "Drama"],
    ratings: [
      1, 7, 6, 6, 8, 3, 10, 6, 4, 6, 10, 1, 2, 4, 10, 5, 3, 7, 1, 7, 6, 9, 7, 6,
      2, 6, 8, 3, 1, 6,
    ],
    poster:
      "MV5BZTJlNmE0ZGMtZGEwNC00YTFjLWEyNTEtOGFmNDU3NjA0MjhiXkEyXkFqcGdeQXVyMjc0MDU2NTM@._V1_SY250_SX250_AL_.jpg",
    contentRating: "",
    duration: "PT132M",
    releaseDate: "2004-01-30",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Macbeth meets the Godfather in present-day Bombay. The Scottish tragedy set in the contemporary underworld of India's commercial capital; two corrupt, fortune telling policemen take the roles of the weird sisters, and \"Duncan\" is Abbaji, the head of a crime family. Abbaji's mistress and Maqbool plot and carry out his death; the sea plays the role of Birnham wood.                Written by\nJames McLeod",
    actors: ["Irrfan Khan", "Tabu", "Pankaj Kapur"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZTJlNmE0ZGMtZGEwNC00YTFjLWEyNTEtOGFmNDU3NjA0MjhiXkEyXkFqcGdeQXVyMjc0MDU2NTM@._V1_SY250_SX250_AL_.jpg",
  },
  {
    title: "Premam",
    year: "2015",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      2, 1, 4, 3, 1, 8, 3, 1, 9, 10, 10, 3, 7, 3, 2, 8, 7, 3, 1, 10, 10, 3, 6,
      10, 4, 6, 7, 7, 10, 9,
    ],
    poster:
      "MV5BMzJhNjMyOGMtYjhiYy00ZTAwLThmZWUtZmE5NzI3OTk4Y2M4XkEyXkFqcGdeQXVyMzQ5Njc3NzU@._V1_SY393_SX295_AL_.jpg",
    contentRating: "",
    duration: "PT156M",
    releaseDate: "2015-05-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "George, a teenager, loves the idea of being in love. This dream seems to be within reach during his school days, then, for a second time during his college days and yet it fails to materialize. This slow metamorphosis of his love, his attempt to woo his lovers, the abrupt failures hardens him but he finally is able to settle down for life with someone much younger, whom he have met during childhood. The film transcends its viewers on perspectives and boundaries of love.",
    actors: ["Nivin Pauly", "Madonna Sebastian", "Sai Pallavi"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMzJhNjMyOGMtYjhiYy00ZTAwLThmZWUtZmE5NzI3OTk4Y2M4XkEyXkFqcGdeQXVyMzQ5Njc3NzU@._V1_SY393_SX295_AL_.jpg",
  },
  {
    title: "Ustad Hotel",
    year: "2012",
    genres: ["Comedy", "Drama", "Musical"],
    ratings: [
      6, 8, 10, 9, 3, 6, 4, 2, 2, 10, 10, 4, 8, 2, 6, 10, 6, 2, 9, 7, 9, 6, 2,
      4, 7, 2, 2, 2, 9, 6,
    ],
    poster:
      "MV5BM2IzYzU4MWMtZDg0ZC00YTJiLWFlMzQtOWI3YmY5NGE1YjQ0XkEyXkFqcGdeQXVyMjM0ODk5MDU@._V1_SY500_CR0,0,374,500_AL_.jpg",
    contentRating: "",
    duration: "PT151M",
    releaseDate: "2012-06-29",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "An urbane chef from a well-to-do family with very high ambitions goes on to find approval from his conservative father, true love and the real purpose of his life.                Written by\nPedantic Pundit",
    actors: ["Dulquer Salmaan", "Thilakan", "Siddique"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BM2IzYzU4MWMtZDg0ZC00YTJiLWFlMzQtOWI3YmY5NGE1YjQ0XkEyXkFqcGdeQXVyMjM0ODk5MDU@._V1_SY500_CR0,0,374,500_AL_.jpg",
  },
  {
    title: "Bangalore Days",
    year: "2014",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      9, 2, 5, 5, 6, 6, 3, 7, 7, 3, 10, 6, 5, 9, 3, 10, 1, 5, 8, 8, 10, 2, 7, 5,
      2, 6, 8, 2, 6, 2,
    ],
    poster:
      "MV5BMjk2Nzc5NmUtMzlhMS00MzRmLWEwNTctMzg0M2EyNjg2NTRjXkEyXkFqcGdeQXVyMjM0ODk5MDU@._V1_SX175_CR0,0,175,233_AL_.jpg",
    contentRating: "",
    duration: "PT171M",
    releaseDate: "2014-05-30",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Bangalore Days begins with an intro from Kuttan (Nivin Pauly) introducing himself and his cousins namely Divya (Nazriya) and Aju (Dulquer) who share a very friendly relationship right from the childhood.They get separated after their schooling but are reunited at Bangalore after the marriage of Divya to Das. The story revolves around how their life turns at Bangalore.                Written by\nVishnu Suresh",
    actors: ["Dulquer Salmaan", "Nazriya Nazim", "Nivin Pauly"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjk2Nzc5NmUtMzlhMS00MzRmLWEwNTctMzg0M2EyNjg2NTRjXkEyXkFqcGdeQXVyMjM0ODk5MDU@._V1_SX175_CR0,0,175,233_AL_.jpg",
  },
  {
    title: "Lage Raho Munna Bhai",
    year: "2006",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      4, 2, 10, 5, 5, 5, 3, 1, 2, 1, 4, 6, 9, 9, 10, 7, 1, 9, 5, 4, 2, 8, 9, 3,
      8, 9, 7, 4, 2, 8,
    ],
    poster:
      "MV5BNzg2NzkzNjU0M15BMl5BanBnXkFtZTgwMTI1MDA2MDE@._V1_SY250_CR0,0,172,250_AL_.jpg",
    contentRating: "",
    duration: "PT144M",
    releaseDate: "2006-09-01",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A hilarious underworld gangster known as Munna Bhai falls comically in love with a radio host by the name of Jahnvi, who runs an elders' home, which is taken over by an unscrupulous builder, who gets the residents kicked out ironically with the help of Munna's sidekick, Circuit, while Munna is busy romancing Jahnvi elsewhere. Munna, who is now masquerading as a Professor specializing in the life of Mahatma Gandhi, must now battle his very own forces and the builder - but he has one ally on his side - none other than the great man - Mahatma Gandhi himself. Only trouble is that Munna may have problems convincing everyone about this presence - as he is apparently is the only one who can see and hear him.                Written by\nSumitra (corrected by Carrie)",
    actors: ["Sanjay Dutt", "Arshad Warsi", "Vidya Balan"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzg2NzkzNjU0M15BMl5BanBnXkFtZTgwMTI1MDA2MDE@._V1_SY250_CR0,0,172,250_AL_.jpg",
  },
  {
    title: "Omkara",
    year: "2006",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      5, 5, 10, 3, 5, 7, 6, 2, 6, 10, 6, 5, 4, 8, 2, 10, 9, 2, 2, 1, 6, 9, 9, 3,
      1, 8, 8, 4, 3, 9,
    ],
    poster:
      "MV5BMTgxMDU2NjUyOF5BMl5BanBnXkFtZTgwOTc3MDA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT155M",
    releaseDate: "2006-07-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Advocate Raghunath Mishra has arranged the marriage of his daughter, Dolly, with Rajan, knowing fully well that Dolly loves Omkara Shukla. Before the marriage could take place, the groom's party is attacked, they flee, and Dolly is reportedly abducted. Raghunath is able to trace Dolly to Omkara, a criminal and hit-man, a verbal confrontation ensues until Politician Bhaisaab telephonically intervenes, and a crestfallen Raghunath faces the reality that Dolly was not abducted but is here with Omkara by her own free will. He warns Omkara, and departs. Shortly thereafter, Bhaisaab is shot at and wounded, announces that Omkara should stand in the next election, and as a result, Omkara appoints one of his lieutenants', Keshav Upadhyay in his place as the 'Bahubali\". Omkara realizes that he may have blundered in having Keshav succeed him, as Keshav is unable to control his temper when under the influence of alcohol, which puts him in the bad books of Omkara. Then Omkara suspects that Keshav ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Ajay Devgn", "Kareena Kapoor", "Saif Ali Khan"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgxMDU2NjUyOF5BMl5BanBnXkFtZTgwOTc3MDA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Dilwale Dulhania Le Jayenge",
    year: "1995",
    genres: ["Comedy", "Drama", "Musical"],
    ratings: [
      4, 7, 7, 2, 8, 6, 9, 2, 9, 9, 10, 3, 9, 8, 4, 3, 8, 1, 7, 6, 10, 10, 3, 9,
      9, 9, 4, 1, 8, 2,
    ],
    poster:
      "MV5BNDk3MTU5MDA3OF5BMl5BanBnXkFtZTgwODM3MzY2MzE@._V1_SY500_CR0,0,365,500_AL_.jpg",
    contentRating: "",
    duration: "PT189M",
    releaseDate: "1995-10-20",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "When Raj (Shahrukh Khan) and Simran (Kajol) first met on an inter-rail holiday in Europe, it wasn't exactly Love at first sight but when Simran is taken back to India for an arranged marriage, things change. Encouraged by his father Dharamvir (Anupam Kher), Raj decides to fly down from London to not just win his Bride but her whole family and the blessings of her father Baldev Singh (Amrish Puri).                Written by\nOfficial Source",
    actors: ["Shah Rukh Khan", "Kajol", "Amrish Puri"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDk3MTU5MDA3OF5BMl5BanBnXkFtZTgwODM3MzY2MzE@._V1_SY500_CR0,0,365,500_AL_.jpg",
  },
  {
    title: "Zindagi Na Milegi Dobara",
    year: "2011",
    genres: ["Adventure", "Comedy", "Drama"],
    ratings: [
      10, 2, 2, 4, 5, 10, 2, 2, 3, 3, 9, 8, 9, 10, 8, 4, 5, 6, 9, 3, 4, 1, 8, 3,
      10, 7, 9, 3, 1, 10,
    ],
    poster:
      "MV5BMzQzMTA4ODY4OF5BMl5BanBnXkFtZTcwNjgyMDQxNw@@._V1_SY500_SX346_AL_.jpg",
    contentRating: "",
    duration: "PT155M",
    releaseDate: "2011-07-15",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Three friends decide to turn their fantasy vacation into reality after one of their number becomes engaged.",
    actors: ["Hrithik Roshan", "Katrina Kaif", "Naseeruddin Shah"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMzQzMTA4ODY4OF5BMl5BanBnXkFtZTcwNjgyMDQxNw@@._V1_SY500_SX346_AL_.jpg",
  },
  {
    title: "Barfi!",
    year: "2012",
    genres: ["Adventure", "Comedy", "Drama"],
    ratings: [
      4, 2, 10, 4, 9, 5, 3, 2, 1, 2, 2, 8, 5, 3, 2, 2, 3, 4, 7, 3, 7, 2, 1, 10,
      4, 7, 7, 10, 3, 5,
    ],
    poster:
      "MV5BMTQzMTEyODY2Ml5BMl5BanBnXkFtZTgwMjA0MDUyMjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT151M",
    releaseDate: "2012-09-14",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Set in the 1970s in a pretty corner of India, Barfi! is the story of three young people who learn that love can neither be defined nor contained by society's norms of normal and abnormal. Barfi, a hearing and speech impaired boy falls in love with Shruti. In spite of her deep affection for Barfii, Shruti gives into societal and parental pressure to marry a 'normal' man and lead a 'normal' life. Many years later their paths cross once again when Barfi, now in love with Jhilmil, is on the run from the police. Barfi is desperately seeking Jhilmil, who has gone missing. Shruti's realization that Jhilmil is autistic makes her recognize that true love is really blind. Caught in a cat and mouse game, in the search for the girl Barfi loves, Shruti realizes that she is still in love with him. She must now choose between her happiness and Barfi! stars three of India's most loved young stars, all essaying roles of a lifetime. The uber cool Ranbir Kapoor plays the lead role of Barfi!, the very ...                Written by\nMohijit Mukerjee",
    actors: ["Ranbir Kapoor", "Priyanka Chopra", "Ileana D'Cruz"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQzMTEyODY2Ml5BMl5BanBnXkFtZTgwMjA0MDUyMjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Ugly",
    year: "2013",
    genres: ["Crime", "Drama", "Mystery"],
    ratings: [
      10, 9, 4, 10, 5, 9, 3, 10, 3, 3, 1, 4, 6, 4, 6, 4, 2, 2, 2, 1, 3, 2, 9, 4,
      6, 7, 7, 4, 4, 8,
    ],
    poster:
      "MV5BNzA0ODUwMzUzNV5BMl5BanBnXkFtZTgwMDA0NTQwMDE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT128M",
    releaseDate: "2014-12-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The film portrays the kidnapping of a little girl of 10, who is out with her father for the day. Her parents are divorced and her stepfather (a cop) steps in for the investigation. The suicidal mother has an ax to grind with both her ex-husband and her current husband. As the investigation proceeds, the characters are placed in sordid scenarios that reveal their unsavory sides; the mind games between the both the fathers in particular lend the procedural its most gripping drama as everyone else is getting greedy and ugly not caring about the kidnapped girl.                Written by\nDeepak Futela",
    actors: ["Rahul Bhat", "Ronit Roy", "Tejaswini Kolhapure"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzA0ODUwMzUzNV5BMl5BanBnXkFtZTgwMDA0NTQwMDE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "The Legend of Bhagat Singh",
    year: "2002",
    genres: ["Biography", "Drama", "History"],
    ratings: [
      10, 4, 6, 3, 3, 8, 8, 3, 8, 2, 4, 9, 8, 4, 2, 4, 6, 4, 2, 3, 6, 9, 8, 8,
      10, 3, 2, 3, 5, 10,
    ],
    poster:
      "MV5BMTc2NGRhMWMtZDdkOS00ZjcxLWI2OTAtOTI3ZWU0YWM3MGM5XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,356,500_AL_.jpg",
    contentRating: "",
    duration: "PT155M",
    releaseDate: "2002-06-07",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Bhagat was born in British India during the year 1908. As a child he witnessed numerous atrocities committed on fellow Indians by their British rulers, who came to trade under the guise of the East India Company, but ended up controlling most of the nation, and permitting tyrants such as General Dyer to massacre thousands of innocent men, women and children in Jallianwala Baug. As a child he was impressed by Mohandas K. Gandhi, especially his call to launch the non-cooperation movement, which led to thousands of people burning British-made clothing, giving up schools, & college studies, and government jobs - only to be let down by Gandhi himself when he called off the movement. Undaunted, Bhagat decided to be a revolutionary, starting with getting into petty fights, then as a grown-up joining the Hindustan Republic Association. When Lala Lajpat Rai was beaten to death by the police, Bhagat, along with Shivram Rajguru, Sukhdev, and others daringly carried out the assassination of a ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Ajay Devgn", "Sushant Singh", "D. Santosh"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc2NGRhMWMtZDdkOS00ZjcxLWI2OTAtOTI3ZWU0YWM3MGM5XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,356,500_AL_.jpg",
  },
  {
    title: "Haider",
    year: "2014",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      5, 6, 1, 8, 5, 1, 10, 7, 8, 5, 8, 6, 5, 7, 6, 6, 1, 9, 8, 6, 8, 6, 6, 6,
      7, 5, 1, 10, 9, 1,
    ],
    poster:
      "MV5BMjA1NTEwMDMxMF5BMl5BanBnXkFtZTgwODkzMzI0MjE@._V1_SY500_CR0,0,345,500_AL_.jpg",
    contentRating: "",
    duration: "PT160M",
    releaseDate: "2014-10-02",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Vishal Bhardwaj's adaptation of William Shakespeare's 'Hamlet', Haider - a young man returns home to Kashmir on receiving news of his father's disappearance. Not only does he learn that security forces have detained his father for harboring militants, but that his mother is in a relationship with his very own uncle. Intense drama follows between mother and son as both struggle to come to terms with news of his father's death. Soon Haider learns that his uncle is responsible for the gruesome murder, what follows is his journey to avenge his father's death.                Written by\nAnonymous",
    actors: ["Shahid Kapoor", "Tabu", "Shraddha Kapoor"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA1NTEwMDMxMF5BMl5BanBnXkFtZTgwODkzMzI0MjE@._V1_SY500_CR0,0,345,500_AL_.jpg",
  },
  {
    title: "Deewaar",
    year: "1975",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      7, 2, 9, 9, 3, 2, 6, 8, 1, 1, 2, 3, 4, 3, 9, 10, 10, 8, 3, 3, 2, 6, 6, 1,
      2, 10, 9, 10, 6, 1,
    ],
    poster:
      "MV5BMTc0NDM4MjYwOV5BMl5BanBnXkFtZTcwMDM3ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
    contentRating: "",
    duration: "PT174M",
    releaseDate: "1975-01-24",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The movie tells the story of two brothers, Vijay and Ravi Verma, who follow different career paths: Vijay is a smuggler and Ravi the policeman who is asked to hunt Vijay down. Vijay Verma (Amitabh Bachchan) and Ravi Verma (Shashi Kapoor) are the sons of a trade unionist, Anand Verma(Satyen Kappu), who was defeated and disgraced by the management of his firm using his family as bait. Unable to bear the public disgrace father deserts the family, and the sons are raised by their mother(Nirupa Roy)who brings them to Bombay City, who suffers the trials and tribulations of a poor single mother. Vijay Verma, the elder brother, grows up with an acute awareness of his father's humiliation and is victimized for his father's supposed misdeeds. In the process of fighting for his rights Vijay, who starts out as a boot polisher and becomes a dockyard worker in his youth, becomes a smuggler and a leading figure of the underworld.                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Shashi Kapoor", "Amitabh Bachchan", "Neetu Singh"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc0NDM4MjYwOV5BMl5BanBnXkFtZTcwMDM3ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
  },
  {
    title: "Mother India",
    year: "1957",
    genres: ["Drama", "Musical", "Family"],
    ratings: [
      2, 8, 4, 5, 10, 9, 5, 5, 9, 9, 2, 2, 2, 6, 9, 4, 9, 1, 3, 5, 9, 10, 2, 5,
      5, 5, 10, 4, 4, 1,
    ],
    poster:
      "MV5BMjE3MzI1MTc1Nl5BMl5BanBnXkFtZTcwMDkwMzMyMQ@@._V1_SY237_CR0,0,165,237_AL_.jpg",
    contentRating: "",
    duration: "PT172M",
    releaseDate: "1957-02-14",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The film begins with the finishing of a water canal for the village set in the present. Radha (Nargis), as the mother of the village, is asked to open the canal and remembers back to her past when she was newly married, mirroring the new independence of India. The wedding between Radha and Shamu (Raaj Kumar) was paid for by Radha's mother-in-law, who got a loan from the moneylender Sukhilala. This event starts the spiral of poverty and hardship that Radha endures. The conditions of the loan are disputed, but the village elders decide in favor of the moneylender, after which Shamu and Radha are forced to pay three-quarters of their crop as interest on the loan of 500 rupees. While trying to use more of their land to alleviate their poverty, Shamu's arms are crushed by a boulder. He is shamed by his helplessness and is humiliated by others in the village. Deciding that he is no use to his family, he leaves and does not return. Soon after this, Radha's mother-in-law dies. Radha continues...                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Nargis", "Sunil Dutt", "Rajendra Kumar"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE3MzI1MTc1Nl5BMl5BanBnXkFtZTcwMDkwMzMyMQ@@._V1_SY237_CR0,0,165,237_AL_.jpg",
  },
  {
    title: "Dev.D",
    year: "2009",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      8, 8, 1, 3, 2, 3, 9, 1, 5, 7, 2, 10, 5, 10, 9, 7, 6, 10, 6, 10, 3, 9, 6,
      10, 10, 8, 8, 1, 4, 1,
    ],
    poster:
      "MV5BYjU1NjczNzYtYmFjOC00NzkxLTg4YTUtNGYzMTk3NTU0ZDE3XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,345,500_AL_.jpg",
    contentRating: "",
    duration: "PT144M",
    releaseDate: "2009-02-06",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Dev who, after spurning Paro's love due to a misunderstanding, turns to drugs and vodka for solace. Paro moves on but Dev still is in remorse. He meets Chanda, a prostitute with problems of her own. Dev likes her but his penchant for self-destruction prevents him and Chanda from truly getting together. He also meets sleazy people like Chunni, Chanda's pimp who drags Dev further into self-destruction to further his own needs.                Written by\nAnonymous",
    actors: ["Abhay Deol", "Mahie Gill", "Kalki Koechlin"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYjU1NjczNzYtYmFjOC00NzkxLTg4YTUtNGYzMTk3NTU0ZDE3XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,345,500_AL_.jpg",
  },
  {
    title: "Masaan",
    year: "2015",
    genres: ["Drama", "Romance"],
    ratings: [
      7, 10, 1, 2, 4, 5, 5, 4, 6, 10, 8, 6, 4, 10, 4, 7, 5, 1, 1, 3, 6, 8, 4, 6,
      6, 6, 1, 1, 1, 8,
    ],
    poster:
      "MV5BMTU4NTE0NTMyNl5BMl5BanBnXkFtZTgwNjI5MDkxNjE@._V1_SY486_SX324_AL_.jpg",
    contentRating: "",
    duration: "PT109M",
    releaseDate: "2015-06-24",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Four lives intersect along the Ganges: a low caste boy hopelessly in love, a daughter ridden with guilt of a sexual encounter ending in a tragedy, a hapless father with fading morality, and a spirited child yearning for a family, long to escape the moral constructs of a small-town.",
    actors: ["Richa Chadha", "Sanjay Mishra", "Vicky Kaushal"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTU4NTE0NTMyNl5BMl5BanBnXkFtZTgwNjI5MDkxNjE@._V1_SY486_SX324_AL_.jpg",
  },
  {
    title: "Anniyan",
    year: "2005",
    genres: ["Action", "Drama", "Thriller"],
    ratings: [
      5, 6, 9, 2, 6, 3, 7, 5, 3, 8, 3, 3, 1, 8, 5, 4, 1, 7, 7, 9, 4, 10, 7, 7,
      3, 5, 10, 2, 7, 6,
    ],
    poster:
      "MV5BNTVkYzdjNGEtNTRhMC00ZjM2LWIyYjgtZjdmYmEzYjZlZTA1XkEyXkFqcGdeQXVyNDY5MTUyNjU@._V1_SY448_SX320_AL_.jpg",
    contentRating: "",
    duration: "PT157M",
    releaseDate: "2005-06-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Ambi is a meek lawyer, who wishes to change the society. But, because of his oft-repeated concern, people don't take him seriously. Besides, Nandini, the girl whom he loves, also rejects her because of this. This makes Ambi shattered, not before he encounters a website Aparichit.com, visiting which creates an alter ego inside Ambi's mind. For the girl he loves, he becomes a supermodel named Remo, and for the entire nation, to reform it, he becomes a vigilante named Aparichit, who not only teaches people the importance of following the rules, but also punishes them if they don't follow.                Written by\nPrashast Singh",
    actors: ["Vikram", "Sada", "Prakash Raj"],
    imdbRating: 8.2,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTVkYzdjNGEtNTRhMC00ZjM2LWIyYjgtZjdmYmEzYjZlZTA1XkEyXkFqcGdeQXVyNDY5MTUyNjU@._V1_SY448_SX320_AL_.jpg",
  },
  {
    title: "Athadu",
    year: "2005",
    genres: ["Action", "Comedy", "Musical"],
    ratings: [
      9, 9, 10, 9, 4, 2, 5, 9, 1, 3, 7, 5, 10, 7, 5, 3, 8, 8, 2, 7, 8, 1, 7, 6,
      4, 4, 3, 6, 7, 3,
    ],
    poster:
      "MV5BYTNkMTMyMDEtZDQxYi00ZjBkLTkyYzYtYzdjY2JmYmRmMjBiXkEyXkFqcGdeQXVyNjE3MDAwMDk@._V1_SY353_SX250_AL_.jpg",
    contentRating: "",
    duration: "PT172M",
    releaseDate: "2005-08-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      'To receive a sympathy vote, a crooked politician plans his own assassination attempt. Nandu is hired to merely wound the politician, but someone else pulls the trigger first. Framed for murder, Nandu flees and meets Pardhu, a man returning home after a long absence. The young man is killed in the police crossfire meant for Nandu. Nandu assumes Pardhu\'s identity and his new "cousin" has a romantic interest in him...                Written by\nL. Hamre',
    actors: ["Mahesh Babu", "Trisha Krishnan", "Prakash Raj"],
    imdbRating: 8.4,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYTNkMTMyMDEtZDQxYi00ZjBkLTkyYzYtYzdjY2JmYmRmMjBiXkEyXkFqcGdeQXVyNjE3MDAwMDk@._V1_SY353_SX250_AL_.jpg",
  },
  {
    title: "Gulaal",
    year: "2009",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      7, 9, 3, 2, 9, 4, 5, 10, 8, 4, 4, 8, 7, 1, 7, 4, 10, 7, 10, 8, 9, 5, 9, 9,
      1, 3, 9, 6, 4, 8,
    ],
    poster:
      "MV5BYzVhYzc2YjMtOGU0Ny00OTg5LWFkZTctOWY1YjI4NzZiMWNiXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SX350_CR0,0,350,467_AL_.jpg",
    contentRating: "",
    duration: "PT140M",
    releaseDate: "2009-03-13",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Bikaner-based 28-year-old Dilip Kumar Singh is enrolled in a Rajpur-based Law college, and rents a room with an unstable male, Rananjay Singh. His attempts to re-locate to a hostel, pits him against a group of men, led by Jadhwal, who not only assault, but also molest him, and then lock him in a dark room with a naked and abused female, Anuja. He recuperates in a hospital and joins hands with Rananjay and Dukey Bana to avenge this humiliation, as well as befriends Anuja, who is a Lecturer in the college. He also decides to support Rananjay, who is legitimate son of a former Raja, to run for college elections - and it is this decision that will shatter and change his life forever.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Kay Kay Menon", "Raj Singh Chaudhary", "Jesse Randhawa"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYzVhYzc2YjMtOGU0Ny00OTg5LWFkZTctOWY1YjI4NzZiMWNiXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SX350_CR0,0,350,467_AL_.jpg",
  },
  {
    title: "Lucia",
    year: "2013",
    genres: ["Drama", "Romance", "Sci-Fi"],
    ratings: [
      8, 1, 7, 9, 10, 7, 10, 5, 7, 9, 6, 3, 9, 2, 5, 4, 1, 6, 6, 8, 5, 9, 10, 2,
      3, 2, 3, 4, 9, 10,
    ],
    poster:
      "MV5BMTQyMDA5ODkzN15BMl5BanBnXkFtZTgwMjIzMDkyMDE@._V1_SY500_CR0,0,342,500_AL_.jpg",
    contentRating: "",
    duration: "PT135M",
    releaseDate: "2013-09-06",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "From the director of smash hit Lifeu Ishtene, Pawan Kumar, comes Lucia, heralding a new direction for Kannada cinema, being the industry's first crowd funded film. An usher at a decrepit cinema suffers from insomnia. His life changes when he starts getting weird and wonderful dreams but with a caveat. Set in the teeming young metropolis that is Bangalore, the film is a turbulent ride where the lines between dreams and reality are blurred to delirious effect.                Written by\nRakesh",
    actors: ["Sathish Neenasam", "Sruthi Hariharan", "Achyuth Kumar"],
    imdbRating: 8.5,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQyMDA5ODkzN15BMl5BanBnXkFtZTgwMjIzMDkyMDE@._V1_SY500_CR0,0,342,500_AL_.jpg",
  },
  {
    title: "Bumbai",
    year: "1995",
    genres: ["Drama", "Musical", "Romance"],
    ratings: [
      8, 8, 4, 6, 2, 6, 6, 5, 9, 8, 5, 6, 10, 4, 9, 8, 3, 5, 6, 5, 8, 1, 3, 1,
      1, 1, 3, 6, 6, 1,
    ],
    poster:
      "MV5BMTU2MzkxODgyMF5BMl5BanBnXkFtZTcwMDk3NDgxMQ@@._V1_SY237_CR0,0,166,237_AL_.jpg",
    contentRating: "",
    duration: "PT141M",
    releaseDate: "1995-03-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Based on true incidents, a south Indian Hindu man falls in love with a Muslim woman--taboo in the small village from which they hail. They marry against family wishes and move to Mumbai, where he works as a reporter for a large daily newspaper. Eventually, the couple has twin boys. The rest of the film is set during the December 1992-January 1993 period when the Ram Janmabhoomi-Babri Masjid controversy raised religious tension in Mumbai and other parts of India, which sparked rioting and violence. The couple is separated from their children, and the fathers of both parents are killed when their home is burned by rioters. A reporter is shown interviewing politicians from both factions as well as the police. An underlying moral of thinking of oneself as an Indian rather than a Hindu or a Muslim is prevalent throughout the latter part of the film. The family is finally reunited after much searching through hospitals, morgues, and shelters. But the violence has left indelible impressions ...                Written by\nMunesh Makhija <mmakhija@trc.tellabs.com>",
    actors: ["Arvind Swamy", "Manisha Koirala", "Tinnu Anand"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTU2MzkxODgyMF5BMl5BanBnXkFtZTcwMDk3NDgxMQ@@._V1_SY237_CR0,0,166,237_AL_.jpg",
  },
  {
    title: "Company",
    year: "2002",
    genres: ["Action", "Crime", "Thriller"],
    ratings: [
      6, 1, 2, 4, 1, 1, 3, 9, 10, 5, 1, 3, 3, 4, 9, 3, 8, 1, 1, 4, 4, 8, 7, 8,
      1, 4, 10, 8, 3, 9,
    ],
    poster:
      "MV5BMGRkNDJlZmEtZGNhNi00OTRhLWE5NDUtYmMwNGZjMzU0MDk5XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_SX346_AL_.jpg",
    contentRating: "",
    duration: "PT155M",
    releaseDate: "2002-04-15",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Mallik is a henchman of Aslam Bhai, a Mumbai underworld kingpin. He inducts local hothead Chandu into the gang, and the two of them soon form a formidable faction within the gang, eventually displacing Aslam. As the empire grows, however, the two of them start drifting apart.                Written by\nJoyojeet Pal",
    actors: ["Ajay Devgn", "Mohanlal", "Manisha Koirala"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMGRkNDJlZmEtZGNhNi00OTRhLWE5NDUtYmMwNGZjMzU0MDk5XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_SX346_AL_.jpg",
  },
  {
    title: "Indian",
    year: "1996",
    genres: ["Action", "Drama"],
    ratings: [
      10, 8, 4, 10, 10, 3, 5, 1, 5, 5, 7, 1, 1, 3, 7, 8, 10, 10, 5, 10, 5, 7, 4,
      7, 5, 3, 6, 5, 6, 7,
    ],
    poster:
      "MV5BMTI3Nzg0Mjg4MF5BMl5BanBnXkFtZTcwNzU3NzQyMQ@@._V1_SY237_CR0,0,163,237_AL_.jpg",
    contentRating: "",
    duration: "PT185M",
    releaseDate: "1996-08-23",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Circa the British rule in India, a man named Senapathy decides to rebel against the British in a violent way, learns a rare martial art that enables him to kill with his bare hands, and travels to Singapore, joins the Indian Liberation Army formed by renowned Subhash Chandra Bose, is one of the soldier's to engage the British into war. He subsequently joins a death squad in order to destroy British tanks. While all of the others succeed in carrying out their mission, Senapathy is captured, jailed, beaten, and mercilessly tortured by the British. Upon his release, he is looked after by a woman named Namrata, whose honor he had saved from the British - who had captured two truckloads of women protesters, burned their clothing, and forced them to commit suicide. Namrata and Senapathy marry, India gains independence, and they soon have two children - Chandrabose and Kasthoori. Years later Chandra quarrels with his honest and straight-laced father, leaves home, so that he can earn enough ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Kamal Haasan", "Nedumudi Venu", "Manisha Koirala"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTI3Nzg0Mjg4MF5BMl5BanBnXkFtZTcwNzU3NzQyMQ@@._V1_SY237_CR0,0,163,237_AL_.jpg",
  },
  {
    title: "Special Chabbis",
    year: "2013",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      5, 6, 5, 5, 6, 8, 3, 7, 4, 2, 1, 4, 10, 10, 2, 1, 1, 6, 6, 6, 3, 1, 1, 4,
      10, 4, 8, 4, 9, 8,
    ],
    poster:
      "MV5BMTQ1NDI5MjMzNF5BMl5BanBnXkFtZTcwMTc0MDQwOQ@@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT144M",
    releaseDate: "2013-02-08",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Based on real life incidents that occurred in India in 1987-88, the storyline revolves around a group of con artists who pulled off many clever robberies during 1980s, and robbed famous businessmen and politicians by pretending to be the CBI or Income tax officers and conducting raids. On the pretext of conducting raids they would take away all the black money hoarded by them.                Written by\nSufiyan Khan and London Mapper",
    actors: ["Anupam Kher", "Manoj Bajpayee", "Akshay Kumar"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ1NDI5MjMzNF5BMl5BanBnXkFtZTcwMTc0MDQwOQ@@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Airlift",
    year: "2016",
    genres: ["Action", "Drama", "History"],
    ratings: [
      10, 8, 10, 8, 10, 4, 9, 2, 7, 4, 5, 3, 9, 4, 3, 4, 1, 2, 6, 6, 3, 7, 4, 6,
      4, 9, 5, 6, 8, 4,
    ],
    poster:
      "MV5BZGE1ZTZhNmQtYzhmNC00MjE4LTg4NDUtY2I4N2Y3OTgwZjljXkEyXkFqcGdeQXVyMTExNDQ2MTI@._V1_SY435_SX300_AL_.jpg",
    contentRating: "",
    duration: "PT130M",
    releaseDate: "2016-01-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "It is in this scenario that Ranjit Katyal (played by Akshay Kumar), a wealthy and powerful Indian businessman, who has always seen himself as a Kuwaiti, rather than an Indian, realizes that he no longer wields any influence on the Iraqis, and that he and his family are in as much danger as anyone else. Ranjit unknowingly becomes the man who all 170,000 Indians look up to for getting them out safely from Kuwait. Airlift is the story of Indians stranded in Kuwait during this traumatic time. A story of how they, with the help of Ranjit Katyal, managed to survive the Iraqi invasion, and against all odds traveled a thousand kilometers across the border into Amman, Jordan. From Amman, 170,000 Indians were brought home by the largest and the most successful evacuation ever attempted by any country, in the history of the world. Over 59 days, the Indian government systematically flew over 488 Air India commercial flights into a war zone to evacuate all 170,000 Indians and safely bring them ...                Written by\nT-Series",
    actors: ["Akshay Kumar", "Nimrat Kaur", "Kumud Mishra"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZGE1ZTZhNmQtYzhmNC00MjE4LTg4NDUtY2I4N2Y3OTgwZjljXkEyXkFqcGdeQXVyMTExNDQ2MTI@._V1_SY435_SX300_AL_.jpg",
  },
  {
    title: "Manjhi: The Mountain Man",
    year: "2015",
    genres: ["Biography", "Drama", "History"],
    ratings: [
      9, 7, 1, 7, 10, 5, 6, 5, 1, 6, 1, 1, 7, 6, 10, 1, 8, 8, 8, 2, 6, 10, 10,
      2, 9, 3, 1, 8, 6, 2,
    ],
    poster:
      "MV5BMjE1NzM3NjkwNl5BMl5BanBnXkFtZTgwMjc1NDUzNjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT120M",
    releaseDate: "2015-08-21",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Dashrath Manjhi was a poor man from the lowest of the low castes, living in a remote village cut off from the world by a rocky mountain range. Life for him was a daily struggle for survival. He loved his wife, Phaguniya, beyond belief. One day, while climbing the mountain to bring him food, his wife slipped, fell and died. Overwhelmed by grief, Dashrath decided to carve out a path through the mountain, so that no one else would suffer his fate. For 22 years, all by himself, with just a hammer and a chisel, he hammered away at the rocks, till the path was carved out from the mountain.                Written by\nKetan Mehta",
    actors: ["Nawazuddin Siddiqui", "Radhika Apte", "Ashutosh Acharya"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE1NzM3NjkwNl5BMl5BanBnXkFtZTgwMjc1NDUzNjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Jab We Met",
    year: "2007",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      3, 10, 2, 1, 10, 4, 10, 5, 4, 5, 2, 7, 8, 4, 3, 10, 4, 6, 3, 6, 9, 7, 7,
      6, 8, 1, 1, 7, 4, 8,
    ],
    poster:
      "MV5BMjExODIzNjU3N15BMl5BanBnXkFtZTcwNjk4NTk5Mw@@._V1_SY250_CR0,0,172,250_AL_.jpg",
    contentRating: "",
    duration: "PT138M",
    releaseDate: "2007-10-26",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Depressed after the passing of his father (Dharamraj) and a ditching by his gorgeous girlfriend, Mumbai-based businessman Aditya Kashyap takes a BEST bus, goes to the Chatrapati Shivaji Train Terminus, and boards a train. There he meets Geet Kaur Dhillon, who is returning home to Bhatinda, and who pays for his ticket. At Bar Nagar, he decides to leave, but she follows him, missing her train. They manage to get a ride to Ratlam, miss the train again, but eventually make it to Bhatinda. Once there, he gets to meet her family, her pretty sister Roop as well as her to-be betrothed, Manjeet Singh Mann. Before the engagement can be finalized, she manages to convince her fiancé that she wants to marry Aditya. Before Aditya can take stock of these new developments, she elopes with him - not to get married but to re-locate to Manali where her true love, Anshuman, awaits, and to whom she hopes to get married.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Shahid Kapoor", "Kareena Kapoor", "Tarun Arora"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjExODIzNjU3N15BMl5BanBnXkFtZTcwNjk4NTk5Mw@@._V1_SY250_CR0,0,172,250_AL_.jpg",
  },
  {
    title: "Vaastav: The Reality",
    year: "1999",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      9, 2, 10, 1, 4, 2, 3, 8, 4, 3, 1, 10, 8, 1, 5, 8, 3, 4, 4, 6, 5, 1, 8, 4,
      7, 5, 7, 3, 9, 6,
    ],
    poster:
      "MV5BMTQwMzE5MTc1OV5BMl5BanBnXkFtZTcwMDk2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
    contentRating: "",
    duration: "PT145M",
    releaseDate: "1999-10-07",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Raghunath Namdev Shivalkar (Sanjay Dutt) and his best friend Dedh Footiya (Sanjay Narvekar) struggle to find work in Mumbai. They decide to run a pav bhaji stall.But fate steps in when Raghu accidentally kills a customer who turns out to be the brother of a notorious gangster, Fracture Pandya and end up in the Mumbai underworld. Vitthal Kaanya (Ashish Vidyarthi), a rival gang lord, offers Raghunath and Dedh Footiya protection and later hires them both as hitmen. Raghunath becomes a respected hit man, with Dedh Footiya as his accomplice. With Raghunath in his gang Vitthal Kaanya hits a peak in the Mumbai underworld. He is protected by a politician who uses Raghunath for his needs. While BabbanRao (Home Minister) relies on Raghunath, there are some others who despise Raghunath, and are just waiting in the sidelines to see when Raghunath makes an error. Raghunath does so, and hence becomes an embarrassment for BabbanRao. Soon Raghunath is on the run, both from the police, and BabbanRao's...                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Sanjay Dutt", "Namrata Shirodkar", "Mohnish Bahl"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQwMzE5MTc1OV5BMl5BanBnXkFtZTcwMDk2ODgzMQ@@._V1_SY250_CR0,0,176,250_AL_.jpg",
  },
  {
    title: "Bajrangi Bhaijaan",
    year: "2015",
    genres: ["Action", "Comedy", "Drama"],
    ratings: [
      3, 1, 2, 8, 5, 7, 5, 4, 5, 1, 10, 5, 8, 2, 10, 10, 2, 1, 5, 8, 9, 2, 3, 6,
      1, 2, 9, 5, 8, 10,
    ],
    poster:
      "MV5BMjE1NjQ5ODc2NV5BMl5BanBnXkFtZTgwOTM5ODIxNjE@._V1_SY500_CR0,0,349,500_AL_.jpg",
    contentRating: "",
    duration: "PT163M",
    releaseDate: "2015-07-17",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A little mute girl from a Pakistan village gets lost on her return back from a trip to India. In Kurukshetra, she meets Pawan - a devout Hanuman Bakth - who is in the midst of a challenge posed by his lover's father. In trying to discover her parents, he develops an unshakable bond with the kid. He tries to get into Pakistan through a path righteous to his conscience and later, with a smart Pakistani news reporter for company and makes the search, a story that captures the imagination of the public in both countries.                Written by\nPipingHotViews [Sivaram]",
    actors: ["Salman Khan", "Kareena Kapoor", "Nawazuddin Siddiqui"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE1NjQ5ODc2NV5BMl5BanBnXkFtZTgwOTM5ODIxNjE@._V1_SY500_CR0,0,349,500_AL_.jpg",
  },
  {
    title: "Ankhon Dekhi",
    year: "2013",
    genres: ["Comedy", "Drama"],
    ratings: [
      2, 8, 1, 2, 7, 4, 4, 10, 9, 7, 5, 2, 10, 3, 3, 10, 7, 1, 2, 6, 2, 7, 4, 6,
      8, 9, 5, 9, 9, 5,
    ],
    poster:
      "MV5BMTQ1ODMzOTA5MV5BMl5BanBnXkFtZTgwOTA2MTAzMjE@._V1_SY250_CR0,0,171,250_AL_.jpg",
    contentRating: "",
    duration: "PT107M",
    releaseDate: "2014-03-21",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Raje Bauji (Sanjay Mishra) is a man in his late fifties, living out a dreary but eventful life in a small house in old Delhi- where he lives with his extended family. A random incident is going to change his life in a dramatic way- though he does not realize at the moment. Bauji's daughter has been seeing a boy of ill repute. When that fact is revealed to the family, after much deliberation they decide to do the obvious- lock up the girl and go beat the willful boy. It is a funny old journey of this man, this old fool- who is both Lear and the fool.                Written by\nWikipedia",
    actors: ["Sanjay Mishra", "Seema Pahwa", "Rajat Kapoor"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ1ODMzOTA5MV5BMl5BanBnXkFtZTgwOTA2MTAzMjE@._V1_SY250_CR0,0,171,250_AL_.jpg",
  },
  {
    title: "Bahubali: The Beginning",
    year: "2015",
    genres: ["Action", "Adventure", "Drama"],
    ratings: [
      7, 2, 7, 8, 7, 6, 1, 10, 2, 8, 6, 5, 8, 7, 2, 7, 1, 3, 6, 1, 9, 3, 5, 10,
      4, 4, 4, 9, 1, 5,
    ],
    poster:
      "MV5BODAwMDc0NzA3Ml5BMl5BanBnXkFtZTgwMjU4NzgyNzE@._V1_SY500_CR0,0,353,500_AL_.jpg",
    contentRating: "",
    duration: "PT159M",
    releaseDate: "2015-07-10",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "When Sanga and her husband, part of a tribe living around the province of Mahismathi, save a drowning infant, little do they know the background of the infant or what the future holds for him. The kid grows up to as Shivudu, a free-spirit wanting to explore the mountains and in the process learns of his roots and then realizes the whole purpose of his life and ends up confronting the mighty Bhallala Deva!                Written by\nPipingHotViews",
    actors: ["Prabhas", "Rana Daggubati", "Anushka Shetty"],
    imdbRating: 8.3,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BODAwMDc0NzA3Ml5BMl5BanBnXkFtZTgwMjU4NzgyNzE@._V1_SY500_CR0,0,353,500_AL_.jpg",
  },
  {
    title: "Kal Ho Naa Ho",
    year: "2003",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      1, 8, 9, 2, 5, 3, 8, 5, 1, 4, 1, 6, 3, 7, 6, 10, 2, 7, 2, 2, 8, 6, 9, 1,
      10, 3, 5, 5, 7, 10,
    ],
    poster:
      "MV5BMTkxNzU2MDczOV5BMl5BanBnXkFtZTcwNTU5NTk5Mw@@._V1_SY250_SX250_AL_.jpg",
    contentRating: "",
    duration: "PT186M",
    releaseDate: "2003-11-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The film's female lead, Naina (Preity Zinta) narrates the story. Her father had committed suicide years ago which left a deep impact on her heart. Her family is dysfunctional since her mother and grandmother just cannot stop arguing. But when Aman (Shahrukh Khan) arrives next door, the whole gloomy conditions change. Aman infuses life in skeptical and overtly serious Naina, and she falls in love with him. But Aman knows that he cannot marry Naina because of a secret which he cannot divulge to her. So he intends upon setting her up with her best pal Rohit (Saif Ali Khan).                Written by\nSoumitra",
    actors: ["Preity Zinta", "Shah Rukh Khan", "Saif Ali Khan"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTkxNzU2MDczOV5BMl5BanBnXkFtZTcwNTU5NTk5Mw@@._V1_SY250_SX250_AL_.jpg",
  },
  {
    title: "Hey Ram",
    year: "2000",
    genres: ["Drama", "History"],
    ratings: [
      9, 4, 9, 5, 8, 10, 4, 2, 8, 2, 2, 7, 3, 5, 6, 4, 10, 10, 6, 4, 2, 9, 6,
      10, 9, 2, 6, 1, 3, 2,
    ],
    poster:
      "MV5BNjI5MTg4MTQ0Ml5BMl5BanBnXkFtZTcwNDI2ODkxMQ@@._V1_SY237_CR0,0,151,237_AL_.jpg",
    contentRating: "",
    duration: "PT186M",
    releaseDate: "2000-02-18",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The film starts with Saketh Ram as a very old man and almost immediately goes into flashback. As a young man he is among his friends, in conviviality. He has taken a Bengali wife, Aparna, and everything is wonderful in his life, However the year is 1946, and the imminent independence of India from British suzerainty is complicated by religious antagonism between the Hindu majority and the large Muslim minority, who demand their own independent state. Saketh and Aparna visit Calcutta; rioting is reported, but Saketh goes out to get some food, and he soon encounters a Hindu woman being chased by Muslim rioters. He rescues her, but the rioters later come to his house, and brutally rape and then kill his wife. Saketh is devastated and takes to the streets, determined personally to kill as many Muslims as he can find. He meets up with Sriram Abhiyankar, who is leading a group of Hindu extremists, and Saketh becomes temporarily taken with the cause himself. At the same time, he is persuaded...                Written by\nHazel Freeman",
    actors: ["Kamal Haasan", "Shah Rukh Khan", "Rani Mukerji"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjI5MTg4MTQ0Ml5BMl5BanBnXkFtZTcwNDI2ODkxMQ@@._V1_SY237_CR0,0,151,237_AL_.jpg",
  },
  {
    title: "Johnny Gaddaar",
    year: "2007",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      3, 5, 5, 9, 1, 9, 3, 7, 3, 2, 3, 1, 7, 6, 10, 1, 5, 8, 1, 5, 5, 9, 8, 1,
      8, 9, 10, 2, 1, 4,
    ],
    poster:
      "MV5BNDE4MmU1YTktMzY1OS00NWQ4LWExZmYtZjI3MzJjNGIxZTcxXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT135M",
    releaseDate: "2007-09-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Plain-clothed police officers, on patrol in a police van in Mumbai's Khar Danda area, recount the story of five crooks: Sheshadari, Shiva, Prakash, Vikram, Shardul, and their Police Inspector friend, Kalyan. The tale revolves around a bag containing 2.5 Crore Rupees that goes missing - resulting in lies, deception, betrayal, and death.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Dharmendra", "Rimi Sen", "Ashwini Kalsekar"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDE4MmU1YTktMzY1OS00NWQ4LWExZmYtZjI3MzJjNGIxZTcxXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Baby",
    year: "2015",
    genres: ["Action", "Adventure", "Crime"],
    ratings: [
      3, 10, 3, 10, 5, 2, 8, 3, 4, 4, 10, 2, 1, 7, 10, 1, 7, 1, 4, 7, 8, 10, 8,
      6, 5, 10, 10, 3, 10, 3,
    ],
    poster:
      "MV5BMjAzMDUzMzk0NV5BMl5BanBnXkFtZTgwODczODg4MzE@._V1_SY499_CR0,0,312,499_AL_.jpg",
    contentRating: "",
    duration: "PT159M",
    releaseDate: "2015-01-23",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The country is perpetually under threat from terrorist powers and the common man walks unaware of the threats and the attacks that our Government controls and prevents. While the common Indian fights for everyday issues, there are deeper and bigger threats to him and his family that he will never know exist because it is the men and women in uniform that safeguard them. The men and women who put country before self, the men and women who define our history because they give a damn! Ajay (played by Akshay Kumar) is one such officer who is part of an elite team chosen from amongst the best in the Forces to form a covert Counter Intelligence Unit. In the course of foiling one terrorist attack bid, Ajay discovers a major threat to our nation - a plan to cause damage and strike fear at the heart of our very existence. The plot is masterminded by a maniacal leader whose organization has its tentacles spread across the world. As days progress, the unit goes through escalating challenges with...",
    actors: ["Akshay Kumar", "Danny Denzongpa", "Rana Daggubati"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjAzMDUzMzk0NV5BMl5BanBnXkFtZTgwODczODg4MzE@._V1_SY499_CR0,0,312,499_AL_.jpg",
  },
  {
    title: "Lakshya",
    year: "2004",
    genres: ["War", "Drama", "Romance"],
    ratings: [
      7, 3, 4, 7, 3, 6, 3, 9, 6, 4, 8, 1, 7, 10, 10, 6, 4, 3, 3, 8, 2, 8, 6, 7,
      10, 9, 10, 8, 5, 7,
    ],
    poster:
      "MV5BMjM5MzQwNTk4OF5BMl5BanBnXkFtZTgwMDc2MTYzNjE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT186M",
    releaseDate: "2004-06-18",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Karan is a lazy good-for-nothing who lives on the generated income of his father and elder brother at their family business. Karan's days: hang out with buddies and romance a woman named Romi. When he watches an action movie, he decides to enlist in the army with a friend, but basic training proves to be too much of a bother and he shortly abandons it, thus making him lose respect on the home front. Romi also stops respecting him. Karan decides he must re-join the army and show his family and Romi that he, too, is focused upon the path he has to take in this lifetime, but will he be resilient enough to carry out this task?                Written by\nSumitra (corrected by Calista / edited by statmanjeff)",
    actors: ["Amitabh Bachchan", "Hrithik Roshan", "Preity Zinta"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjM5MzQwNTk4OF5BMl5BanBnXkFtZTgwMDc2MTYzNjE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "My Name Is Khan",
    year: "2010",
    genres: ["Adventure", "Drama", "Romance"],
    ratings: [
      2, 5, 4, 9, 2, 5, 3, 1, 1, 4, 2, 5, 5, 5, 1, 6, 6, 9, 1, 2, 9, 7, 6, 7, 9,
      4, 6, 10, 6, 10,
    ],
    poster:
      "MV5BMTUyMTA4NDYzMV5BMl5BanBnXkFtZTcwMjk5MzcxMw@@._V1_SY500_CR0,0,337,500_AL_.jpg",
    contentRating: "11",
    duration: "PT165M",
    releaseDate: "2010-02-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Rizwan Khan, a Muslim from the Borivali section of Mumbai, suffers from Asperger's syndrome, a form of high-functioning autism that complicates socialization. The adult Rizwan marries a Hindu single mother, Mandira, in San Francisco. After 9/11, Rizwan is detained by authorities at LAX who mistake his disability for suspicious behavior. Following his arrest, he meets Radha, a therapist who helps him deal with his situation and his affliction. Rizwan then begins a journey to meet US President Bush to clear his name.                Written by\nAuntie A",
    actors: ["Shah Rukh Khan", "Kajol", "Sheetal Menon"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTUyMTA4NDYzMV5BMl5BanBnXkFtZTcwMjk5MzcxMw@@._V1_SY500_CR0,0,337,500_AL_.jpg",
  },
  {
    title: "Gangaajal",
    year: "2003",
    genres: ["Crime", "Drama"],
    ratings: [
      7, 9, 9, 7, 4, 8, 8, 1, 3, 9, 10, 5, 5, 6, 2, 9, 7, 3, 9, 6, 2, 2, 9, 10,
      6, 4, 1, 9, 10, 10,
    ],
    poster:
      "MV5BYjRjOWViZTgtYjA4Ny00MWJiLTkxYzktMzdlOGRmMWYwOTdjXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,372,500_AL_.jpg",
    contentRating: "",
    duration: "PT157M",
    releaseDate: "2003-08-29",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "An SP Amit Kumar who is given charge of Tezpur police station in Bihar. The area is full of corruption, inefficiency, bribery, nepotism, favoritism and crime with help from the local police. Gradually Amit realizes that the local politician Sadhu Yadav is the one who benefits the most out of it. Amit arrests Sunder Yadav, Sadhu's son. While Sunder is released soon, some police officers, get frustrated with the system, and pour acid into the eyes of two of Yadav's men, blinding them. A hue and cry is raised by the media, crime almost comes to a standstill, and the police are regarded with respect. SP Amit Kumar must now put an end to this kind of situation.                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Ajay Devgn", "Gracy Singh", "Mohan Joshi"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYjRjOWViZTgtYjA4Ny00MWJiLTkxYzktMzdlOGRmMWYwOTdjXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,372,500_AL_.jpg",
  },
  {
    title: "English Vinglish",
    year: "2012",
    genres: ["Comedy", "Drama", "Family"],
    ratings: [
      10, 9, 3, 8, 4, 7, 4, 3, 1, 3, 6, 5, 9, 10, 9, 7, 7, 7, 7, 3, 4, 10, 7, 7,
      3, 2, 7, 7, 7, 7,
    ],
    poster:
      "MV5BMjQ5YWVmYmYtOWFiZC00NGMxLWEwODctZDM2MWI4YWViN2E5XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_CR0,0,349,500_AL_.jpg",
    contentRating: "",
    duration: "PT134M",
    releaseDate: "2012-10-05",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The story of a quiet, sweet tempered housewife who endures small slights from her well educated husband and daughter everyday because of her inability to speak and understand English. She is resourceful and open-minded but somehow these traits don't get noticed by them. Then one day on a trip to visit her sister in Manhattan she decides to enroll in an English Learners class and meets a host of new people who teach her to value herself beyond the narrow perspective of her family.                Written by\nParoma",
    actors: ["Sridevi", "Adil Hussain", "Mehdi Nebbou"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjQ5YWVmYmYtOWFiZC00NGMxLWEwODctZDM2MWI4YWViN2E5XkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_SY500_CR0,0,349,500_AL_.jpg",
  },
  {
    title: "Border",
    year: "1997",
    genres: ["Action", "War"],
    ratings: [
      4, 10, 8, 8, 10, 6, 10, 5, 2, 10, 2, 5, 4, 4, 5, 3, 10, 5, 10, 6, 3, 2,
      10, 6, 8, 4, 3, 4, 8, 9,
    ],
    poster:
      "MV5BYzZjNzE4MjMtODExYS00MGJhLWJmZDUtMmJkYWZlN2VjNTkzXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,335,500_AL_.jpg",
    contentRating: "",
    duration: "PT176M",
    releaseDate: "1997-06-13",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The year is 1971 when the Pakistani Army is at war with the Indian Soldiers. The Indian battalion is posted in Longewala region in Punjab and are just 150 in number while the Pakistani Army consists of 2000 armed soldiers with tanks. This movie is a landmark in Hindi Cinema and watch how the drama unfolds and the Indian soldiers fight for the pride of their motherland. Commendable performances from Jackie Shroff, Sudesh Berry, Sunil Shetty and Sunny Deol and excellent acting by Akshay Khanna.                Written by\nKanhaiya Maheshwary",
    actors: ["Rakhee Gulzar", "Sunny Deol", "Jackie Shroff"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYzZjNzE4MjMtODExYS00MGJhLWJmZDUtMmJkYWZlN2VjNTkzXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,335,500_AL_.jpg",
  },
  {
    title: "Manam",
    year: "2014",
    genres: ["Comedy", "Drama", "Fantasy"],
    ratings: [
      4, 3, 5, 10, 7, 2, 4, 9, 4, 9, 8, 6, 9, 6, 7, 2, 6, 7, 4, 6, 2, 10, 4, 9,
      2, 3, 7, 3, 4, 8,
    ],
    poster:
      "MV5BMTYzMjc3NzEzMV5BMl5BanBnXkFtZTgwNzI3NzU4MzE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT163M",
    releaseDate: "2014-05-23",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Radha (Naga Chaitanya) and Krishna (Samantha) are a married couple with a kid Bittu in early 1980's. They die in an accident. Bittu (Nagarjuna) grows up and happens to see reincarnation of his father and his mother as youngsters. The rest of the story is all about how Bittu tries to unite these two youngsters. And there is another twist in the tale for which you must watch the movie on the big screen!                Written by\nJeevi",
    actors: [
      "Akkineni Nageshwara Rao",
      "Nagarjuna Akkineni",
      "Naga Chaitanya Akkineni",
    ],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYzMjc3NzEzMV5BMl5BanBnXkFtZTgwNzI3NzU4MzE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Rock On!!",
    year: "2008",
    genres: ["Drama", "Music"],
    ratings: [
      3, 5, 5, 5, 8, 7, 7, 6, 5, 8, 6, 2, 7, 3, 4, 6, 4, 9, 3, 10, 4, 5, 8, 3,
      4, 9, 1, 7, 1, 7,
    ],
    poster:
      "MV5BMTM2NjIwODc4N15BMl5BanBnXkFtZTcwMDgwMzM4MQ@@._V1_SY500_CR0,0,345,500_AL_.jpg",
    contentRating: "",
    duration: "PT145M",
    releaseDate: "2008-08-29",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Sakshi Shroff, the lonely and neglected wife of busy banking executive, Aditya, decides to give him a surprise on his birthday on July 22nd, but ends surprising him not once but multiple times. While Aditya is thrilled to know that both are going to be parents, and did appear surprised by the celebration, bitterness creeps in when he notices that Sakshi had also invited some ghosts (Rob Nancy and Kedar Zaveri) from his past. This gives rise to unpleasant memories involving a failed music group 'Magik' that he had associated with about a decade ago. Sakshi will soon find out why Aditya is displeased with her; why the music group broke up, ending in violence and acrimony especially between her husband and his former friend, Joseph Mascarenhas; why they cannot perform together ever again; as well as contemplate moving out and living with her mom.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Arjun Rampal", "Farhan Akhtar", "Luke Kenny"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM2NjIwODc4N15BMl5BanBnXkFtZTcwMDgwMzM4MQ@@._V1_SY500_CR0,0,345,500_AL_.jpg",
  },
  {
    title: "Okkadu",
    year: "2003",
    genres: ["Action", "Romance"],
    ratings: [
      3, 8, 3, 3, 5, 3, 7, 3, 5, 8, 7, 8, 8, 8, 4, 9, 8, 8, 5, 1, 7, 1, 7, 2, 5,
      1, 5, 2, 9, 1,
    ],
    poster:
      "MV5BNjE4NWY1YWMtM2U4ZS00NjdjLThhZDAtZWQ0NmVlZDE0NTNjXkEyXkFqcGdeQXVyMzc5Nzk1NDY@._V1_SX364_CR0,0,364,383_AL_.jpg",
    contentRating: "",
    duration: "PT170M",
    releaseDate: "2003-01-15",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A kabaddi player (Mahesh) comes to Kurnool for match, there he rescues a girl from village goon Obul Reddy (Prakash raj) and takes her to his home and makes arrangements for her higher studies in a foreign country. But she refuses to leave him. Is romance on the cards?                Written by\nvamsireddy-43470",
    actors: ["Mahesh Babu", "Bhoomika Chawla", "Prakash Raj"],
    imdbRating: 8.1,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjE4NWY1YWMtM2U4ZS00NjdjLThhZDAtZWQ0NmVlZDE0NTNjXkEyXkFqcGdeQXVyMzc5Nzk1NDY@._V1_SX364_CR0,0,364,383_AL_.jpg",
  },
  {
    title: "Don",
    year: "1978",
    genres: ["Action", "Crime", "Thriller"],
    ratings: [
      1, 2, 9, 3, 7, 9, 9, 5, 6, 7, 8, 4, 9, 5, 5, 10, 7, 4, 2, 7, 4, 4, 6, 2,
      1, 2, 8, 1, 4, 7,
    ],
    poster:
      "MV5BYTYwZjA0NmMtZWJmYy00ZTZlLWEzZTEtZGJhYTQ1NzFkNDQ3XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "",
    duration: "PT175M",
    releaseDate: "1978-05-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A ruthless gangster named Don is killed during a scuffle with the police. Since only DSP Desilva knows of this incident, he recruits another person named Vijay who is a spitting image of Don. Vijay is planted in Don's place in Don's gang and DeSilva has a plan to nab the entire gang in this way. But when Desilva dies during a raid, the secret that Vijay is not Don is also buried with him. Now Vijay is on the run - from the police and the criminal gang - and has to find the last piece of evidence to prove his real identity before it is too late.                Written by\nSoumitra",
    actors: ["Amitabh Bachchan", "Zeenat Aman", "Pran"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYTYwZjA0NmMtZWJmYy00ZTZlLWEzZTEtZGJhYTQ1NzFkNDQ3XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Oye Lucky! Lucky Oye!",
    year: "2008",
    genres: ["Comedy", "Crime", "Drama"],
    ratings: [
      4, 10, 1, 8, 2, 4, 7, 1, 6, 8, 5, 5, 9, 7, 4, 3, 4, 2, 4, 1, 1, 2, 10, 6,
      5, 3, 6, 6, 10, 9,
    ],
    poster:
      "MV5BNjA1MjM2NTM3MV5BMl5BanBnXkFtZTcwODIyMjk5MQ@@._V1_SY500_CR0,0,350,500_AL_.jpg",
    contentRating: "",
    duration: "PT125M",
    releaseDate: "2008-11-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Inspired by the incredible true story of Lucky Singh, an extremely charismatic and fearless confidence man and thief who socialized with the rich, famous and influential of Delhi society and then proceeded to rob them blind. He was the bête noire of the police and had stolen millions by the time he was caught. A modern day Robin Hood with a twist, he robbed both the rich and the poor without prejudice. Nothing was too big nor was anything too insignificant to escape his attention. The film opens with his trial and charts his rise from the projects of crime ridden suburban Delhi to the very heart of the corridors of power. Along the way he makes lifelong friends, falls in love an manages to outwit the entire law and order machinery.                Written by\nAnonymous",
    actors: ["Abhay Deol", "Paresh Rawal", "Neetu Chandra"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjA1MjM2NTM3MV5BMl5BanBnXkFtZTcwODIyMjk5MQ@@._V1_SY500_CR0,0,350,500_AL_.jpg",
  },
  {
    title: "Mr. India",
    year: "1987",
    genres: ["Action", "Adventure", "Comedy"],
    ratings: [
      1, 5, 2, 10, 2, 10, 10, 5, 7, 4, 2, 1, 10, 8, 3, 8, 6, 4, 8, 9, 4, 9, 6,
      1, 1, 2, 10, 6, 6, 4,
    ],
    poster:
      "MV5BNjJjNjEyOTEtNDhhZi00MDM1LWExMTYtZmNjNDE1OTQ2OTE0XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SX350_CR0,0,350,469_AL_.jpg",
    contentRating: "",
    duration: "PT179M",
    releaseDate: "1987-05-25",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Orphan Arun Verma utilizes his adult-hood in raising orphan children, in a house where he is unable to make ends as well as fulfilled the living expenses. International criminal and smuggler, Mogambo, wants his house to store arms and ammunition and thus give him a time-frame to vacate. Arun then decides to arrange for a tenant named Seema Sohni, a local newspaper journalist, to occupy the top flat of the house. Mogambo's men then decides to force Arun to vacate by targeting him and the children. Eventually Arun's dad's friend, Professor Sinha, introduces him to a gadget that will make him invisible, he tries this device and becomes invisible only to retaliates on Mogambo's men calling himself, \"Mr. India\". He also becomes popular among the people by assisting the ones who are subjected to injustice, no one knows who is this, \"Mr. India\", except Jugal. Things comes to a boil when one of Arun's children is killed while the others, Seema and he are abducted by Mogambo, who threatens to ...                Written by\ngavin (racktoo@hotmail.com)",
    actors: ["Anil Kapoor", "Sridevi", "Amrish Puri"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjJjNjEyOTEtNDhhZi00MDM1LWExMTYtZmNjNDE1OTQ2OTE0XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SX350_CR0,0,350,469_AL_.jpg",
  },
  {
    title: "RangiTaranga",
    year: "2015",
    genres: ["Adventure", "Music", "Mystery"],
    ratings: [
      2, 2, 3, 2, 4, 1, 6, 5, 1, 8, 8, 8, 7, 4, 4, 10, 1, 4, 1, 5, 5, 9, 3, 3,
      6, 4, 4, 8, 7, 1,
    ],
    poster:
      "MV5BMTAzNjAwNDEwMTNeQTJeQWpwZ15BbWU4MDk5MjMyMzYx._V1_SY499_CR0,0,337,499_AL_.jpg",
    contentRating: "",
    duration: "PT149M",
    releaseDate: "2015-07-03",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Gautam, a novelist leads a reclusive life in Ooty. Gautam's latest novel is titled RangiTaranga, a word which might hold the key to his past. Indu, a soft natured girl, paints the cover pages of all Gautam's novels. Sandhya, a self proclaimed journalist, is in search of an anonymous writer who goes by the pen name \"ANASHKU\". Unforeseen circumstances lead Gautam to Indu's ancestral home in the village of Kamarottu. Upon his arrival in Kamarottu, he befriends the post master, Kalinga, and the elderly school head master, Shankara. Gautam experiences a lot of strange occurrences and his investigation into these incidents irks the powerful men in the village. Meanwhile, Sandhya's trail leads her to Kamarottu. And then, the unexpected happens!!!                Written by\npran ur",
    actors: ["Nirup Bhandari", "Radhika Chetan", "Avantika Shetty"],
    imdbRating: 8.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTAzNjAwNDEwMTNeQTJeQWpwZ15BbWU4MDk5MjMyMzYx._V1_SY499_CR0,0,337,499_AL_.jpg",
  },
  {
    title: "Udta Punjab",
    year: "2016",
    genres: ["Crime", "Drama", "Thriller"],
    ratings: [
      9, 4, 5, 6, 4, 3, 2, 6, 4, 2, 5, 8, 6, 4, 4, 8, 5, 8, 10, 10, 2, 2, 9, 4,
      2, 9, 4, 4, 4, 2,
    ],
    poster:
      "MV5BOWQ0MzY2MzYtMGIzYi00ODdjLWIyMjQtZDM1N2ZjOWRlNzIxXkEyXkFqcGdeQXVyNjY1MTg4Mzc@._V1_SX300_CR0,0,300,433_AL_.jpg",
    contentRating: "",
    duration: "PT148M",
    releaseDate: "2016-06-17",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "What on earth can a rock star, a migrant laborer, a doctor and a cop possibly have in common? Simple, Punjab! 4 lives, 1 connection - 'Udta Punjab' takes you on a trip like never before. Shahid Kapoor, Kareena Kapoor, Alia Bhatt and Diljit Dosanjh play characters from different walks of life, fighting the menace of drugs in their own way. The film journeys into the artificial highs and the real lows that they face while treading the paths fraught with mortal dangers. But above all, Udta Punjab is about the famed Punjabi spirit, that despite being fully down, has the audacity of looking you in the eye and saying - Drugs di maa di!",
    actors: ["Alia Bhatt", "Shahid Kapoor", "Diljit Dosanjh"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOWQ0MzY2MzYtMGIzYi00ODdjLWIyMjQtZDM1N2ZjOWRlNzIxXkEyXkFqcGdeQXVyNjY1MTg4Mzc@._V1_SX300_CR0,0,300,433_AL_.jpg",
  },
  {
    title: "The Lunchbox",
    year: "2013",
    genres: ["Drama", "Romance"],
    ratings: [
      5, 6, 10, 8, 1, 8, 6, 10, 4, 5, 10, 1, 4, 8, 7, 2, 5, 6, 2, 4, 8, 8, 1, 9,
      6, 9, 3, 2, 2, 1,
    ],
    poster:
      "MV5BMTUwMzc1NjIzMV5BMl5BanBnXkFtZTgwODUyMTIxMTE@._V1_SY500_CR0,0,339,500_AL_.jpg",
    contentRating: "Btl",
    duration: "PT104M",
    releaseDate: "2014-04-25",
    averageRating: 0,
    originalTitle: "Dabba",
    storyline:
      "The film, set in Mumbai, revolves around a mistaken delivery by the Dabbawalas (lunchbox service) of Mumbai, which leads to a relationship between Saajan, a lonely widower close to retirement, and Ila, an unhappy housewife, as they start exchanging notes through the daily lunchbox.                Written by\nIceman",
    actors: ["Irrfan Khan", "Nimrat Kaur", "Nawazuddin Siddiqui"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTUwMzc1NjIzMV5BMl5BanBnXkFtZTgwODUyMTIxMTE@._V1_SY500_CR0,0,339,500_AL_.jpg",
  },
  {
    title: "Vicky Donor",
    year: "2012",
    genres: ["Comedy", "Romance"],
    ratings: [
      1, 4, 8, 1, 4, 4, 7, 9, 10, 1, 2, 7, 10, 8, 2, 4, 6, 3, 7, 6, 5, 6, 7, 9,
      7, 9, 1, 3, 7, 4,
    ],
    poster:
      "MV5BMTQwMTcyMjY3OV5BMl5BanBnXkFtZTcwNjU0MjY2Nw@@._V1_SY500_CR0,0,380,500_AL_.jpg",
    contentRating: "",
    duration: "PT126M",
    releaseDate: "2012-04-20",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Dr. Baldev Chaddha (Anu Kapoor), a well qualified fertility expert, runs a fertility clinic and a sperm bank in Dariyaganj, New Delhi, that guarantees a high quality and specialized sperm for the purpose. Unfortunately he has more failed cases to his credit than successes. A healthy, high performing donor is the need of the hour. Vicky Arora (Ayushmann Khurrana), a young, good-looking, Punjabi boy from Lajpat Nagar, is the only son and of no financial support to Dolly, a widow, who runs a small beauty parlor from home. As luck would have it, a small brawl in the colony brings Dr Chaddha and Vicky, face to face, where Chaddha, concludes that Vicky could be THAT donor he has been looking for. From here on, Chaddha's days and nights are spent in convincing Vicky to become a donor till he finally gives in. Vicky finds his love interest in Ashima Roy (Yami Gautam), a pretty Bengali girl, who works in a Bank. But soon there hunky dory world comes crashing down because of Vicky's past as a ...                Written by\nOfficial site",
    actors: ["Ayushmann Khurrana", "Yami Gautam", "Annu Kapoor"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQwMTcyMjY3OV5BMl5BanBnXkFtZTcwNjU0MjY2Nw@@._V1_SY500_CR0,0,380,500_AL_.jpg",
  },
  {
    title: "Kapoor & Sons",
    year: "2016",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      3, 10, 8, 6, 7, 8, 5, 6, 5, 9, 8, 7, 2, 1, 3, 9, 4, 7, 4, 6, 2, 3, 3, 4,
      6, 5, 9, 1, 3, 2,
    ],
    poster:
      "MV5BMjE4NDk4MTIwNl5BMl5BanBnXkFtZTgwNDEwODI5NzE@._V1_SY500_SX350_AL_.jpg",
    contentRating: "",
    duration: "PT132M",
    releaseDate: "2016-03-17",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A story revolving around a dysfunctional family of 2 brothers who visit their family and discover that their parents marriage is on the verge of collapse,the family is undergoing a financial crunch and much more as the drama unfolds.",
    actors: ["Sidharth Malhotra", "Fawad Khan", "Alia Bhatt"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE4NDk4MTIwNl5BMl5BanBnXkFtZTgwNDEwODI5NzE@._V1_SY500_SX350_AL_.jpg",
  },
  {
    title: "Nayak: The Real Hero",
    year: "2001",
    genres: ["Drama", "Action"],
    ratings: [
      1, 10, 2, 3, 7, 5, 5, 8, 4, 2, 2, 10, 10, 2, 5, 7, 7, 8, 1, 7, 9, 5, 3, 2,
      1, 10, 4, 8, 1, 2,
    ],
    poster:
      "MV5BMDYwMzRmY2YtZWM4Mi00MmViLTk1OWUtYTU1MzYzMDU0MTE1XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_SX400_AL_.jpg",
    contentRating: "",
    duration: "PT187M",
    releaseDate: "2001-09-07",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Employed as a camera-man at a popular television station QTV; Shivaji Rao Gaekwad work his way up and is eventually promoted as a reporter. One of his job involve interviewing the Chief Minister Balraj Chauhan. During the course of the interview he brings to light the true facts of Chauhan to the general public. Agrivated at this Chauhan decides that he will challenge him to become the Chief Minister for a day which he accepts. During his tenure Shivaji attempts to make the wrong right by punishing dishonest people while at the same time ensure that the masses get what they aspire for. But when his life return to normal he will find that nothing is the same anymore as he and his loved ones are made targets by Chauhan's goons this pushes Shivaji to enter politics and eventually elect as the Chief Minister - a Chief Minister who wants to continue the remaining of his day's work.                Written by\ngavin (racktoo@hotmail.com)",
    actors: ["Anil Kapoor", "Rani Mukerji", "Amrish Puri"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMDYwMzRmY2YtZWM4Mi00MmViLTk1OWUtYTU1MzYzMDU0MTE1XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_SX400_AL_.jpg",
  },
  {
    title: "Samsara",
    year: "2001",
    genres: ["Adventure", "Drama", "Romance"],
    ratings: [
      9, 4, 7, 5, 4, 10, 9, 1, 10, 7, 9, 10, 7, 6, 3, 10, 9, 7, 9, 7, 4, 6, 2,
      5, 9, 6, 9, 5, 5, 10,
    ],
    poster:
      "MV5BMTY2NTY0OTQzOV5BMl5BanBnXkFtZTcwNTQxNDMzMQ@@._V1_SY200_SX139_AL_.jpg",
    contentRating: "7",
    duration: "PT145M",
    releaseDate: "2003-04-04",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A spiritual love-story set in the majestic landscape of Ladakh, Himalayas. Samsara is a quest; one man's struggle to find spiritual Enlightenment by renouncing the world. And one woman's struggle to keep her enlightened love and life in the world. But their destiny turns, twists and comes to a surprise ending...                Written by\nMonsoon Films",
    actors: ["Shawn Ku", "Christy Chung", "Neelesha Barthel"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTY2NTY0OTQzOV5BMl5BanBnXkFtZTcwNTQxNDMzMQ@@._V1_SY200_SX139_AL_.jpg",
  },
  {
    title: "Guru",
    year: "2007",
    genres: ["Biography", "Drama", "Musical"],
    ratings: [
      1, 4, 10, 5, 9, 7, 2, 9, 6, 10, 5, 3, 6, 5, 5, 7, 6, 1, 2, 2, 10, 3, 6, 2,
      4, 10, 7, 2, 8, 2,
    ],
    poster:
      "MV5BMjAzMTkyMTQ0MF5BMl5BanBnXkFtZTcwMjIxNjA0MQ@@._V1_SY300_CR0,0,208,300_AL_.jpg",
    contentRating: "",
    duration: "PT166M",
    releaseDate: "2007-01-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "A school-teacher in India sires a son named Gurukant, but is disappointed as the child fails to live up to his high expectations. When Gurukant grows up, he is unable to secure decent employment in India, so finds a way to go to Turkey, where he finds employment. When he returns back to India, he wants to start his own business, but is unable to do so, as he does not have enough money. So he does some research, gets to meet Sujata, the daughter of a wealthy man named Jignesh, and marries her. After the marriage, Gurukant finds out that Sujata has a dark past, but he ignores this - for his one motive is to be to rise in the eyes of his father - and get rich.                Written by\nCarrie",
    actors: [
      "Mithun Chakraborty",
      "Abhishek Bachchan",
      "Aishwarya Rai Bachchan",
    ],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjAzMTkyMTQ0MF5BMl5BanBnXkFtZTcwMjIxNjA0MQ@@._V1_SY300_CR0,0,208,300_AL_.jpg",
  },
  {
    title: "Aamir",
    year: "2008",
    genres: ["Drama", "Thriller"],
    ratings: [
      5, 3, 3, 1, 1, 8, 7, 9, 1, 10, 8, 8, 6, 1, 10, 9, 2, 9, 8, 9, 1, 7, 10, 2,
      10, 10, 3, 3, 10, 8,
    ],
    poster:
      "MV5BMjA0NTU4OTIzNl5BMl5BanBnXkFtZTgwODE2MjA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT99M",
    releaseDate: "2008-06-06",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Aamir Ali lives a middle-classed lifestyle in Mumbai along with his dad, Rashid; mom, Taranum; three sisters: Nargis, Shabana, and Falak; and a brother, Jameel. After his dad passes away, Aamir re-locates to Britain, studies, obtains a medical degree, and returns home. Upon arrival at Mumbai Airport, he is hassled by the Customs Officer and his baggage is searched several times. Finally, he is permitted to leave. Outside the airport he is approached by two men on a motorbike, and one of them hands him a cellphone. Aamir accepts the cellphone and thus begins his nightmare that will propel him all the way to Dongri, then to Bhendi Bazar, where he will be given a red suitcase containing cash. He will be told that he must deliver this suitcase at another location within a specified time or else his family will all be killed. Aamir agrees to do so but before he could even arrive at the location, the suitcase gets stolen. The question remains: will Aamir be able to locate it and deliver it ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Rajeev Khandelwal", "Aishwarya", "Vasan Bala"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA0NTU4OTIzNl5BMl5BanBnXkFtZTgwODE2MjA2MDE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Earth",
    year: "1998",
    genres: ["Drama", "Romance", "War"],
    ratings: [
      3, 9, 7, 1, 5, 7, 1, 9, 4, 4, 2, 5, 10, 5, 1, 9, 2, 2, 5, 4, 8, 10, 1, 1,
      4, 10, 5, 6, 9, 6,
    ],
    poster:
      "MV5BMTkxNzQ2ODYyNl5BMl5BanBnXkFtZTcwMzY5MjYxMQ@@._V1_SY237_CR0,0,166,237_AL_.jpg",
    contentRating: "",
    duration: "PT110M",
    releaseDate: "1999-07-07",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The movie opens in Lahore of 1947 before India and Pakistan became independent. It is a cosmopolitan city, depicted by the coterie of working class friends who are from different religions. The rest of the movie chronicles the fate of this group and the maddening religious that sweeps even this city as the partition of the two countries is decided and Lahore is given to Pakistan.                Written by\nNeel V Kumar <neelvk@iname.com>",
    actors: ["Aamir Khan", "Nandita Das", "Rahul Khanna"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTkxNzQ2ODYyNl5BMl5BanBnXkFtZTcwMzY5MjYxMQ@@._V1_SY237_CR0,0,166,237_AL_.jpg",
  },
  {
    title: "Eega",
    year: "2012",
    genres: ["Comedy", "Drama", "Fantasy"],
    ratings: [
      10, 2, 5, 9, 9, 10, 5, 6, 5, 8, 7, 4, 9, 8, 7, 2, 9, 7, 10, 6, 7, 3, 6, 6,
      7, 6, 6, 10, 5, 7,
    ],
    poster:
      "MV5BNzhiN2YzZDYtYjQzMy00YTVkLTk4OTItYTQ0ODllMGM5NjA1XkEyXkFqcGdeQXVyMzU0ODc1MTQ@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "",
    duration: "PT145M",
    releaseDate: "2012-07-06",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Sudeep is a high profile industrialist who gets whatever he wants and he has a special eye for beautiful women. To get them, he will not hesitate to do anything. That desire gets triggered when Sudeep sees Bindu, a micro artist who runs a non-profit organization. However, Bindu is loved by Nani who keeps following her everywhere. Though Bindu loves him, she doesn't express it to him and enjoys the attention. The story takes a turn when Sudeep discovers the feelings of Bindu for Nani and is unable to digest his defeat. He kills Nani. But Nani is born again as 'Eega'(fly) and he wants to take vengeance on Sudeep.                Written by\nVishNu Teja",
    actors: ["Sudeep", "Nani", "Samantha Ruth Prabhu"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzhiN2YzZDYtYjQzMy00YTVkLTk4OTItYTQ0ODllMGM5NjA1XkEyXkFqcGdeQXVyMzU0ODc1MTQ@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Neerja",
    year: "2016",
    genres: ["Biography", "Drama", "Thriller"],
    ratings: [
      1, 5, 5, 4, 6, 3, 5, 5, 7, 3, 2, 7, 8, 8, 3, 4, 9, 4, 9, 5, 1, 2, 5, 10,
      8, 4, 6, 4, 7, 4,
    ],
    poster:
      "MV5BYzMxM2EwMzctOWUzYy00ZTNkLWE3ZjYtYjI5NWUzZTMwZDAwXkEyXkFqcGdeQXVyNTE0MDc0NTM@._V1_SY500_CR0,0,345,500_AL_.jpg",
    contentRating: "",
    duration: "PT122M",
    releaseDate: "2016-02-19",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Neerja is the story of the courageous Neerja Bhanot, who sacrificed her life while protecting the lives of 359 passengers on the Pan Am flight 73 in 1986. The flight was hijacked by a terrorist organization.",
    actors: ["Sonam Kapoor", "Shabana Azmi", "Yogendra Tikku"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BYzMxM2EwMzctOWUzYy00ZTNkLWE3ZjYtYjI5NWUzZTMwZDAwXkEyXkFqcGdeQXVyNTE0MDc0NTM@._V1_SY500_CR0,0,345,500_AL_.jpg",
  },
  {
    title: "Agneepath",
    year: "1990",
    genres: ["Action", "Crime", "Drama"],
    ratings: [
      6, 6, 5, 8, 3, 1, 5, 3, 6, 2, 8, 1, 1, 8, 7, 10, 5, 2, 3, 2, 5, 1, 2, 8,
      9, 9, 7, 6, 4, 4,
    ],
    poster:
      "MV5BMjE2NDA0ODgyMF5BMl5BanBnXkFtZTgwMTk4MTI5NTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
    contentRating: "",
    duration: "PT174M",
    releaseDate: "1990-02-16",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Vijay (Amitabh Bachchan) father is brutally lynched by villagers after being framed by Kancha Cheena (Danny Denzongpa), and his family is forced to flee. The young Vijay vows revenge, and grows up protecting his sister and mother by becoming a gangster himself. Eventually he works his way up the ladder until he is face to face with the men who killed his father, but by this time he is little different from them, and his actions have put his family in the line of danger once more.                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Amitabh Bachchan", "Mithun Chakraborty", "Madhavi"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE2NDA0ODgyMF5BMl5BanBnXkFtZTgwMTk4MTI5NTE@._V1_SY250_CR0,0,187,250_AL_.jpg",
  },
  {
    title: "Pokiri",
    year: "2006",
    genres: ["Action", "Comedy"],
    ratings: [
      2, 7, 9, 6, 3, 1, 5, 9, 1, 6, 5, 7, 4, 3, 10, 6, 9, 6, 7, 10, 2, 1, 9, 9,
      7, 9, 2, 9, 9, 8,
    ],
    poster:
      "MV5BNmI0ZjU4MmItNWQyMS00NDNiLTlhMzctZjIyZDBiOTdlM2FiXkEyXkFqcGdeQXVyNjE2NTgxOTE@._V1_SY200_SX164_AL_.jpg",
    contentRating: "",
    duration: "PT164M",
    releaseDate: "2006-04-28",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Pandu is a killer for hire, and will accept any contract provided the amount is right. The Police want him for questioning, while the underworld needs him to silence their opponents. No one really knows this assassin's background. It is only Pandu who knows his real identity and he has no intention of sharing it with anyone.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Mahesh Babu", "Ileana D'Cruz", "Prakash Raj"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNmI0ZjU4MmItNWQyMS00NDNiLTlhMzctZjIyZDBiOTdlM2FiXkEyXkFqcGdeQXVyNjE2NTgxOTE@._V1_SY200_SX164_AL_.jpg",
  },
  {
    title: "Pyaar Ka Punchnama",
    year: "2011",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      9, 4, 7, 4, 2, 1, 7, 2, 7, 5, 2, 8, 8, 2, 7, 7, 4, 6, 2, 6, 3, 4, 5, 7, 9,
      4, 1, 9, 1, 4,
    ],
    poster:
      "MV5BODc1MDAyMDAtYTdiZS00NWVhLTk0YjItNGZjOTdmNjlkZGM2XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,321,500_AL_.jpg",
    contentRating: "",
    duration: "PT149M",
    releaseDate: "2011-05-20",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Outspoken and overly critical Nishant Agarwal meets gorgeous new co-worker, Charu, offers his help, assists her financially, and they become close friends. His room-mates, Rajat and Vikrant, are pleased with this outcome as they already have girlfriends in Neha and Rhea respectively. But both the relationships are not as harmonious, as Rajat feels Neha is self-centered and demanding, while Rhea appears to be withdrawn and aloof. Missing their meetings and bar-hopping, the trio decide to take a time-out and be by themselves. All three women, however, find out and decide to accompany them to the beach where they eventually mingle. The trio do not know that soon misunderstandings will crop up - and it will take a lot of effort and understanding to resolve them.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Kartik Aaryan", "Raayo S. Bakhirta", "Ranjit Batra"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BODc1MDAyMDAtYTdiZS00NWVhLTk0YjItNGZjOTdmNjlkZGM2XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,321,500_AL_.jpg",
  },
  {
    title: "Veer-Zaara",
    year: "2004",
    genres: ["Drama", "Musical", "Romance"],
    ratings: [
      8, 5, 9, 3, 2, 1, 8, 7, 8, 8, 5, 2, 2, 8, 3, 10, 8, 5, 6, 9, 8, 7, 1, 10,
      3, 1, 1, 2, 3, 6,
    ],
    poster:
      "MV5BMTI1Njc3ODg1Ml5BMl5BanBnXkFtZTcwNDYxNDcyMQ@@._V1_SX250_CR0,0,250,338_AL_.jpg",
    contentRating: "",
    duration: "PT192M",
    releaseDate: "2004-11-12",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Veer Pratap Singh (Shah Rukh Khan) is an officer and pilot in the Indian Air Force who one day meets a beautiful Pakistani heiress, Zaara Hayaat Khan (Preity Zinta), as she travels to a small Indian village to scatter the ashes of one of her family's loyal servants. Veer has family in the village, and while most Indians show no affection for Pakistanis, his aunt and uncle are willing to take Zaara in for the night. It isn't long before Veer finds himself falling for her; however, Veer learns that Zaara is engaged to another man, Raza (Manoj Bajpai), a cruel and humorless Pakistani. A friend of Zaara contacts Veer and tells him that Zaara wants out of her engagement and has strong feelings for him, but when he comes to her rescue, matters take a turn for the worse and Veer winds up in jail. Twenty years later, Veer is still behind bars, and finds that his case is being given a new trial, but while he has a new chance at freedom, he discovers his lawyer will be going up against a state ...                Written by\ngavin@sunny_deol2009@yahoo.com",
    actors: ["Shah Rukh Khan", "Preity Zinta", "Rani Mukerji"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTI1Njc3ODg1Ml5BMl5BanBnXkFtZTcwNDYxNDcyMQ@@._V1_SX250_CR0,0,250,338_AL_.jpg",
  },
  {
    title: "Sarkar",
    year: "2005",
    genres: ["Crime", "Drama"],
    ratings: [
      2, 1, 2, 6, 2, 10, 1, 6, 10, 2, 9, 7, 3, 1, 3, 4, 4, 6, 3, 4, 4, 3, 8, 9,
      1, 6, 10, 9, 7, 1,
    ],
    poster:
      "MV5BMjI4MzkxNTkzNl5BMl5BanBnXkFtZTcwNzQ5MzAxOQ@@._V1_SY500_CR0,0,363,500_AL_.jpg",
    contentRating: "",
    duration: "PT124M",
    releaseDate: "2005-07-01",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Meet Subhash Nagre - a wealthy and influential resident of Bombay. He lives in a palatial house with his wife, Pushpa; sons Vishnu and his wife Amrita and their son; a second son, named Shankar, in the United States. Subhash and his family are thrilled when Shankar returns home, in the company of a gorgeous long-legged young woman named Pooja, who he plans to marry soon. While Subhash adores both his sons, he shows his open disappointment for Vishnu, whose language, childish actions, and his affair with a Bollywood actress named Sapna are just few of his wrong actions. When Vishnu finds out that a Bollywood actor is attempting to start an affair with Sapna, he angrily guns him down in front of several witnesses. Subhash asks Vishnu to leave the house, and thereafter Vishnu is arrested and charged with murder. Then all hell breaks lose in the Nagre household when a politician named Motilal Khurana is killed, and the killer names Subhash as the person who hired him to do this killing. ...                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Amitabh Bachchan", "Abhishek Bachchan", "Kay Kay Menon"],
    imdbRating: 7.7,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjI4MzkxNTkzNl5BMl5BanBnXkFtZTcwNzQ5MzAxOQ@@._V1_SY500_CR0,0,363,500_AL_.jpg",
  },
  {
    title: "Madras Cafe",
    year: "2013",
    genres: ["Action", "Drama", "History"],
    ratings: [
      2, 1, 10, 8, 9, 2, 5, 4, 3, 5, 7, 4, 2, 7, 8, 1, 9, 1, 4, 3, 8, 8, 2, 6,
      2, 8, 7, 8, 9, 5,
    ],
    poster:
      "MV5BMTg1MzU5ODM4Nl5BMl5BanBnXkFtZTcwOTQ3MTM5OQ@@._V1_SY222_SX150_AL_.jpg",
    contentRating: "",
    duration: "PT130M",
    releaseDate: "2013-08-23",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "An Indian Intelligence agent (portrayed by John Abraham)[9] journeys into a war torn coastal island, to break a resolute rebel group. He deftly maneuvers his resources to make significant breakthroughs, amidst a scenario where the enemy has no face and the only counsel is 'Don't get caught.' At various junctions, he meets a charismatic and passionate journalist (portrayed by Nargis Fakhri) who is following her will to reflect the truth behind the civil war. The story unfolds as their quest for the truth reveals a deeper conspiracy, by a faceless enemy, united to seize a common nemesis - India.                Written by\nAnonymous",
    actors: ["Nargis Fakhri", "John Abraham", "Avijit Dutt"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTg1MzU5ODM4Nl5BMl5BanBnXkFtZTcwOTQ3MTM5OQ@@._V1_SY222_SX150_AL_.jpg",
  },
  {
    title: "M.S. Dhoni: The Untold Story",
    year: "2016",
    genres: ["Biography", "Drama", "Sport"],
    ratings: [
      8, 5, 1, 4, 10, 4, 3, 5, 10, 1, 8, 4, 3, 9, 4, 6, 7, 3, 1, 3, 9, 2, 6, 4,
      1, 8, 1, 8, 5, 4,
    ],
    poster:
      "MV5BOTY5ODQxMTY3M15BMl5BanBnXkFtZTgwOTA3NTA4OTE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT184M",
    releaseDate: "2016-09-30",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Mahendra Singh Dhoni is a goalkeeper in school football team.Bannerjee a school cricket coach asks him to join his cricket team and practice daily with him for two hours time passes and he becomes a big state level cricketer but for a long time his luck doesn't favor him to become a member of Indian Cricket team.Dhoni takes up a job in Indian Railways as a ticket checker and plays cricket for the railways after long wait of 4 years he gets selected in Indian Cricket team and turns to be one of the best cricketing captains in history of Indian Cricket.                Written by\nalex.mjacko@gmail.com",
    actors: ["Disha Patani", "Anupam Kher", "Sushant Singh Rajput"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOTY5ODQxMTY3M15BMl5BanBnXkFtZTgwOTA3NTA4OTE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Kabhi Haan Kabhi Naa",
    year: "1994",
    genres: ["Comedy", "Drama", "Music"],
    ratings: [
      6, 2, 3, 6, 3, 3, 1, 7, 2, 2, 9, 4, 2, 4, 3, 9, 2, 5, 3, 1, 4, 9, 8, 5, 8,
      5, 6, 2, 9, 9,
    ],
    poster:
      "MV5BM2UzZDIzNTAtYWMxMS00MGRhLWJiM2MtNGMzZGZiMGQ3N2VjXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "",
    duration: "PT158M",
    releaseDate: "1994-02-25",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Sunil and some of his friends start a band and perform at weddings and special occasions. Sunil is in love with Aana but Aana loves Chris; when Sunil finds out about this he decides to utilize the best of his powers to prevent the couple from meeting only to stand exposed in the eyes of Aana who throws him out from the music band. He finds an opportunity coming his way when Chris' parents arrange his marriage elsewhere but another calamity occurs when when Chris finds out that he failed his exam forcing him to forge a certificate which states that he is successful at the exam in the eyes of his parents.                Written by\ngavin (racktoo@hotmail.com)",
    actors: ["Shah Rukh Khan", "Suchitra Krishnamoorthi", "Deepak Tijori"],
    imdbRating: 8.0,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BM2UzZDIzNTAtYWMxMS00MGRhLWJiM2MtNGMzZGZiMGQ3N2VjXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Tanu Weds Manu Returns",
    year: "2015",
    genres: ["Comedy", "Drama", "Romance"],
    ratings: [
      2, 3, 4, 6, 5, 3, 8, 2, 8, 2, 2, 6, 4, 8, 6, 3, 4, 10, 1, 3, 4, 8, 4, 8,
      9, 2, 9, 7, 5, 10,
    ],
    poster:
      "MV5BMjMwMTExMjA1OV5BMl5BanBnXkFtZTgwNDI5MTcyNjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
    contentRating: "",
    duration: "PT128M",
    releaseDate: "2015-05-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Tanu and Manu's marriage collapses. What happens when Manu meets Tanu's lookalike Kusum - and when Tanu returns?",
    actors: ["Kangana Ranaut", "Madhavan", "Mohammed Zeeshan Ayyub"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMwMTExMjA1OV5BMl5BanBnXkFtZTgwNDI5MTcyNjE@._V1_SY500_CR0,0,346,500_AL_.jpg",
  },
  {
    title: "Darr",
    year: "1993",
    genres: ["Drama", "Romance", "Thriller"],
    ratings: [
      7, 3, 7, 3, 3, 3, 3, 7, 7, 1, 6, 6, 8, 6, 8, 3, 2, 9, 6, 6, 8, 9, 8, 9,
      10, 4, 1, 4, 3, 1,
    ],
    poster:
      "MV5BOTczMzA1OWUtYTFlZS00NzUzLTg0MjQtNTUzMDE4MmVjZjgyXkEyXkFqcGdeQXVyNTE0MDc0NTM@._V1_SY427_CR0,0,304,427_AL_.jpg",
    contentRating: "",
    duration: "PT178M",
    releaseDate: "1993-12-24",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Darr is a girl's (Kiran) story caught between one man's (Sunil) love and another man's (Rahul) obsession.",
    actors: ["Shah Rukh Khan", "Juhi Chawla", "Sunny Deol"],
    imdbRating: 7.9,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOTczMzA1OWUtYTFlZS00NzUzLTg0MjQtNTUzMDE4MmVjZjgyXkEyXkFqcGdeQXVyNTE0MDc0NTM@._V1_SY427_CR0,0,304,427_AL_.jpg",
  },
  {
    title: "Bheja Fry",
    year: "2007",
    genres: ["Comedy", "Drama"],
    ratings: [
      2, 2, 2, 2, 6, 10, 10, 1, 8, 8, 8, 10, 7, 2, 7, 5, 1, 2, 5, 1, 2, 8, 3, 8,
      1, 5, 8, 5, 8, 7,
    ],
    poster:
      "MV5BZWRmNDIwNWMtNTI3YS00MTZjLWJmNzctOGYwYzc4ZThiNWM5XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
    contentRating: "",
    duration: "PT95M",
    releaseDate: "2007-04-13",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Ranjeet Thadani lives a wealthy lifestyle in Mumbai along with his wife, Sheetal, who is a singer, while he manages Soundtrack Industries. At the request of his friend, Jagdish Verma, he decides to invite a singer and Libran, Bharat Bhushan, to his residence for dinner, as well as listen to him sing. Ranjeet, suffering from back pain, does not realize that Bharat is also an Income-Tax Inspector, and upon arrival at Ranjeet's residence, will virtually and hilariously turn his life upside down.                Written by\nrAjOo (gunwanti@hotmail.com)",
    actors: ["Vinay Pathak", "Rajat Kapoor", "Sarika"],
    imdbRating: 7.7,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZWRmNDIwNWMtNTI3YS00MTZjLWJmNzctOGYwYzc4ZThiNWM5XkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SY500_CR0,0,333,500_AL_.jpg",
  },
  {
    title: "Kuch Kuch Hota Hai",
    year: "1998",
    genres: ["Comedy", "Drama", "Musical"],
    ratings: [
      3, 2, 2, 6, 3, 10, 10, 2, 5, 5, 2, 5, 8, 1, 1, 3, 5, 5, 6, 9, 4, 2, 1, 5,
      9, 3, 9, 5, 5, 9,
    ],
    poster:
      "MV5BMTI0MjIxNzEwOF5BMl5BanBnXkFtZTcwMDcwOTUxMQ@@._V1_SX169_CR0,0,169,237_AL_.jpg",
    contentRating: "",
    duration: "PT177M",
    releaseDate: "1998-10-16",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "Rahul Khanna and Anjali Sharma were best friends at college. Anjali realizes that she has fallen for Rahul but she's too late because Rahul has already fallen for Tina Malhotra. Heartbroken, Anjali leaves the city. Tina and Rahul get married and soon Tina becomes pregnant, giving birth to a daughter which they call Anjali. Due to complications during pregnancy, Tina passes away. Anjali is brought up by her father, and each year on her birthday he allows his daughter to read one of her mother's letters. Through these letters she learns that her mother (Tina) knew that another Anjali was in love with Rahul, and vows to bring them together again.                Written by\nSoumitra",
    actors: ["Shah Rukh Khan", "Kajol", "Rani Mukerji"],
    imdbRating: 7.8,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTI0MjIxNzEwOF5BMl5BanBnXkFtZTcwMDcwOTUxMQ@@._V1_SX169_CR0,0,169,237_AL_.jpg",
  },
  {
    title: "Kai po che!",
    year: "2013",
    genres: ["Drama", "Sport"],
    ratings: [
      4, 7, 10, 5, 7, 7, 6, 5, 5, 5, 3, 7, 4, 4, 1, 2, 6, 3, 7, 2, 6, 1, 6, 9,
      3, 8, 8, 5, 1, 7,
    ],
    poster:
      "MV5BMTgwNTAwMjEzMF5BMl5BanBnXkFtZTcwNzMzODY4OA@@._V1._CR10,12.166671752929688,793,1053.000015258789_SY500_CR0,0,376,500_AL_.jpg",
    contentRating: "",
    duration: "PT120M",
    releaseDate: "2013-02-22",
    averageRating: 0,
    originalTitle: "",
    storyline:
      "The story goes around the three friends who start a business, also providing coaching classes and tuition. Omi asks for help with his uncle, who is also a political leader, to start this business. Govind provides tuition classes to some children and Ishaan gives cricket coaching. They come to meet a boy, Ali who is gifted with hyper-reflex. Ishaan then starts special coaching for the boy so that the country gets a new star player. But unexpected things happen suddenly and the story takes a turn.                Written by\nNebzyl",
    actors: ["Amit Sadh", "Sushant Singh Rajput", "Rajkummar Rao"],
    imdbRating: 7.7,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgwNTAwMjEzMF5BMl5BanBnXkFtZTcwNzMzODY4OA@@._V1._CR10,12.166671752929688,793,1053.000015258789_SY500_CR0,0,376,500_AL_.jpg",
  },
  {
    title: "Detective Byomkesh Bakshy!",
    year: "2015",
    genres: ["Action", "Drama", "Thriller"],
    ratings: [
      8, 3, 4, 6, 7, 6, 5, 4, 4, 5, 4, 3, 10, 3, 8, 10, 3, 1, 2, 3, 6, 7, 2, 3,
      9, 1, 5, 9, 9, 5,
    ],
    poster:
      "MV5BMjMyNzQ0MTAxNl5BMl5BanBnXkFtZTgwMDY2NjM4MzE@._V1_SY500_CR0,0,320,500_AL_.jpg",
    contentRating: "",
    duration: "PT139M",
    releaseDate: "2015-04-03",
    averageRating: 0,
    originalTitle: "",
    storyline:
      '"CALCUTTA 1943 A WAR - A MYSTERY - and A DETECTIVE" Detective Byomkesh Bakshy is based on the early exploits of India\'s first true-blue detective, created by Bengali bestseller writer Saradindu Bandyopadhyay. Directed by Dibakar Banerjee, the film is set in the Second World War torn Calcutta during the 1940s and follows the first adventure of Byomkesh Bakshy (Sushant Singh Rajput), fresh out of college, as he pits himself against an evil genius who is out to destroy the world. Using his wits against the most villainous arch criminal the world has seen, in a world of murder, international political intrigue and seduction.                Written by\nOfficial source',
    actors: ["Sushant Singh Rajput", "Anand Tiwari", "Neeraj Kabi"],
    imdbRating: 7.7,
    posterurl:
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMyNzQ0MTAxNl5BMl5BanBnXkFtZTgwMDY2NjM4MzE@._V1_SY500_CR0,0,320,500_AL_.jpg",
  },
];

const getMovies = () => {
  return movies;
};
const getGenres = () => {
  const genres = new Set();
  movies.forEach((movie) => {
    if (Array.isArray(movie.genres)) {
      movie.genres.forEach((g) => genres.add(g));
    }
  });

  const convertedGenres = Array.from(genres); // ['drama','action']
  return convertedGenres.map((g, idx) => ({ id: idx + 1, name: g }));
};
export { getMovies, getGenres };
